// Same storefront API root as assets/boostify-subscriptions.js (account tab).
const BOOSTIFY_STOREFRONT_API = '/apps/boostify/api/storefront';
// Same as extensions/subscription-widget/assets/order-repeat-button.js (FULL_ORDER repeat).
const BOOSTIFY_CART_ATTR_ORDER_REPEAT = '_boostify_order_repeat';

function shopifyCartJsonPath(resource) {
  const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  const base = root.endsWith('/') ? root.slice(0, -1) : root;
  const path = resource.startsWith('/') ? resource : `/${resource}`;
  return (base || '') + path;
}

/** 10% subscriber discount from 2nd weekly charge; monthly estimate uses ~4 weeks. */
const OTP_SUB_WEEKLY_DISCOUNT_RATE = 0.1;
const OTP_EST_WEEKS_PER_MONTH = 4;
/** Minimum main-dish count (tag עיקריות) required for weekly subscription checkout. */
const OTP_MIN_WEEKLY_MEALS = 5;

/** Fixed מארז SKUs: one line item = full box meal count (not 1). */
const PROMEAL_FIXED_BOX_MEALS = {
  'מארז-עלייה-במסה': 10,
  'מארז-ירידה-במשקל': 10,
};
const PROMEAL_FIXED_BOX_MEALS_BY_VARIANT = {
  '45675211554977': 10,
  '45670205161633': 10,
};

function fixedBoxMealCountForLineItem(item) {
  if (!item) return null;
  const handle = item.handle || '';
  if (PROMEAL_FIXED_BOX_MEALS[handle]) return PROMEAL_FIXED_BOX_MEALS[handle];
  const vid = String(item.variant_id || item.id || '');
  if (PROMEAL_FIXED_BOX_MEALS_BY_VARIANT[vid]) return PROMEAL_FIXED_BOX_MEALS_BY_VARIANT[vid];
  return null;
}

/**
 * When true: date step goes straight to checkout as one-time (no order-type screen).
 * false = show subscription vs one-time step (drawer) before checkout.
 * Temporarily true — hide weekly subscription checkout until re-enabled.
 */
const PROMEAL_SKIP_ORDER_TYPE_STEP = true;

/** Default selection on order-type step (weekly subscription). */
const PROMEAL_DEFAULT_ORDER_TYPE_CHOICE = 'sub';

/**
 * Slow checkout debugging — enable ONE of:
 *   sessionStorage.setItem('debug_delivery_checkout','1'); location.reload()
 *   ?debugCheckout=1 on the URL
 * Console: each line is TOTAL ms since click reset | STEP ms since previous await | label
 * Theme JS ends at form.submit — time until checkout **page** paints includes Shopify checkout document + scripts (see Network).
 */
function isDeliveryCheckoutDebug() {
  try {
    if (typeof sessionStorage !== 'undefined' && sessionStorage.getItem('debug_delivery_checkout') === '1') {
      return true;
    }
    if (typeof localStorage !== 'undefined' && localStorage.getItem('debug_delivery_checkout') === '1') {
      return true;
    }
    if (typeof location !== 'undefined' && /(?:^|[?&])debugCheckout=1(?:&|$)/.test(location.search)) {
      return true;
    }
  } catch (e) {
    /* ignore */
  }
  return false;
}

let _deliveryCheckoutDebugT0 = 0;
let _deliveryCheckoutDebugLastT = 0;

function printDeliveryCheckoutDebugHelpOnce() {
  if (!isDeliveryCheckoutDebug() || window.__promealDeliveryCheckoutHelpPrinted) return;
  window.__promealDeliveryCheckoutHelpPrinted = true;
  console.info(
    `[delivery-checkout] HOW TO READ THIS\n` +
      `• STEP ms = time spent in the previous chunk (one await / one loop iteration).\n` +
      `• TOTAL ms = time since "timer reset" (start of finalizeOrderTypeAndCheckout).\n` +
      `• After the last log, the browser loads checkout — open Network → Doc → first checkout HTML request → Timing (wait vs download).\n` +
      `• Filter XHR/Fetch for cart.js, cart/change.js, cart/update.js, boostify — sum "Waiting for server response".\n` +
      `• Disable: sessionStorage.removeItem('debug_delivery_checkout')`
  );
}

function deliveryCheckoutDebugReset() {
  if (!isDeliveryCheckoutDebug()) return;
  _deliveryCheckoutDebugT0 = performance.now();
  _deliveryCheckoutDebugLastT = _deliveryCheckoutDebugT0;
  printDeliveryCheckoutDebugHelpOnce();
  console.log('[delivery-checkout] timer reset — next lines are from order-type → checkout click');
}

function deliveryCheckoutDebugStep(label, detail) {
  if (!isDeliveryCheckoutDebug()) return;
  const t = performance.now();
  if (!_deliveryCheckoutDebugT0) {
    _deliveryCheckoutDebugT0 = t;
    _deliveryCheckoutDebugLastT = t;
    printDeliveryCheckoutDebugHelpOnce();
  }
  const totalMs = (t - _deliveryCheckoutDebugT0).toFixed(0);
  const stepMs = (t - _deliveryCheckoutDebugLastT).toFixed(0);
  _deliveryCheckoutDebugLastT = t;
  const tail = detail !== undefined ? detail : '';
  console.log(`[delivery-checkout] ${totalMs}ms total | ${stepMs}ms step | ${label}`, tail);
  try {
    performance.mark(`delivery-checkout:${label}`);
  } catch (e) {
    /* ignore */
  }
}

function deliveryCheckoutDebug(label, detail) {
  deliveryCheckoutDebugStep(label, detail);
}

// Global array to track all delivery frequency instances
window.deliveryFrequencyInstances = window.deliveryFrequencyInstances || [];

// Make the class available globally
window.DeliveryFrequencySelector = class DeliveryFrequencySelector {
  constructor(selector) {
    this.selector = selector;
    if (!this.selector) return;
    
    this.panel = this.selector.querySelector('.delivery-date-panel');
    this.overlay = this.selector.querySelector('.delivery-panel-overlay');
    this.dateOptions = this.selector.querySelector('#dateOptions');
    this.totalAmountElement = this.selector.querySelector('#deliveryTotalAmount');
    this.freeShippingLabel = this.selector.querySelector('[data-free-shipping]');
    this.paidShippingLabel = this.selector.querySelector('[data-paid-shipping]');
    
    this.selectedDate = null;
    this.selectedFrequency = 'onetime';
    this.currentStep = 1;
    this.cartTotal = 0;
    
    // Determine if this is a drawer or page instance.
    this.isDrawer = this.selector.id === 'DrawerDeliveryFrequencySelector' || 
                    this.selector.closest('.drawer') !== null ||
                    this.selector.closest('[data-js-site-cart-sidebar]') !== null;
    this.instanceType = this.isDrawer ? 'drawer' : 'page';
    
    this.isModal = this.selector.classList.contains('delivery-frequency-modal');
    
    this.orderTypeFlowEnabled = !!this.selector.querySelector('[data-order-type-panel]');
    this.sundayAckEl = this.selector.querySelector('[data-delivery-sunday-ack]');
    this.orderTypePanel = this.selector.querySelector('[data-order-type-panel]');
    this._closestSundayDate = null;
    this.orderTypePhase = 'date';
    this.orderTypeChoice = PROMEAL_DEFAULT_ORDER_TYPE_CHOICE;
    this._orderTypeListenersBound = false;
    this._plansCacheByProductId = {};
    this._plansCacheAll = undefined;
    this._fullOrderPlansCache = undefined;
    this._customerSubsCache = undefined;
    /** Set in applyOrderTypeToCartLines (once / full_order); merged in updateCartWithDeliveryInfoAsync to skip extra cart/update. */
    this._pendingBoostifyOrderRepeatForCheckout = undefined;
    if (this.orderTypeFlowEnabled) {
      if (PROMEAL_SKIP_ORDER_TYPE_STEP) {
        this.orderTypeChoice = 'once';
        sessionStorage.setItem('promeal_order_type_choice', 'once');
        this.selector.classList.add('promeal-delivery--skip-order-type-step');
        const ctaLbl = this.selector.querySelector('[data-confirm-btn-label]');
        const ts = window.themeOrderTypeStrings;
        if (ctaLbl && ts && ts.cta) ctaLbl.textContent = ts.cta;
        const checkoutNum = this.selector.querySelector(
          '.stepper-new--three [data-step-phase="checkout"] .stepper-num'
        );
        if (checkoutNum) checkoutNum.textContent = '2';
        if (this.orderTypePanel) this.applyOrderTypeChoiceToCards();
      } else {
        this.setDefaultOrderTypeChoice();
      }
    }

    this.init();
    
    // Add this instance to the global array
    window.deliveryFrequencyInstances.push(this);
    
    // Listen for cart updates
    document.addEventListener('cart-updated', this.handleCartUpdate.bind(this));
    
    // Reset delivery date when page is unloaded (user navigates away)
    window.addEventListener('beforeunload', () => {
      if (!this.selectedFrequency) {
        // Only reset if the user hasn't completed the selection process
        localStorage.removeItem('tempSelectedDate');
        localStorage.removeItem('selectedDeliveryDate');
      }
    });
  }
  
  init() {
    console.log(`Initializing DeliveryFrequencySelector (${this.instanceType})`);
    
    // Check if customer is signed in and has a subscription
    this.checkCustomerStatus();
    
    // Generate delivery dates
    this.generateDateOptions();
    
    // Load saved selections from localStorage
    this.loadSavedSelections();
    
    // Initialize event listeners
    this.initEventListeners();
    
    // Compare cart with last order if customer has subscription
    this.compareCartWithLastOrder();
    
    // Display saved selections in cart (but don't select them in the UI)
    this.displaySavedSelectionsInCart();
    
    // Listen for the show-delivery-selector event
    document.addEventListener('show-delivery-selector', (event) => {
      if (event.detail?.boostifyCardUpdate) {
        try {
          sessionStorage.setItem('promeal_boostify_card_update', '1');
          sessionStorage.setItem(
            'promeal_order_type_choice',
            PROMEAL_SKIP_ORDER_TYPE_STEP ? 'once' : 'sub'
          );
        } catch (e) {
          /* ignore */
        }
      }
      // Only respond if this instance is the target or no target is specified
      const targetType = event.detail?.target;
      if (!targetType || targetType === this.instanceType) {
        this.showDeliverySelector(event.detail?.isDrawer);
      } else {
        console.log(`Ignoring event - targeted at ${targetType}, this is ${this.instanceType}`);
      }
    });
    
    // Listen for cart updates to reload delivery dates
    document.addEventListener('cart:delivery-dates-reload', this.handleDeliveryDatesReload.bind(this));
    
    // Store the current cart state for comparison
    this.cartState = {
      hasOutOfStock: this.checkCartForOutOfStockItems(),
      itemCount: document.querySelectorAll('.cart-item').length
    };
    
    // Update confirm button text
    this.updateConfirmButtonText();
    
    console.log("DeliveryFrequencySelector initialization complete");
  }
  
  // Check if customer is signed in and has a subscription
  checkCustomerStatus() {
    // Check if customer is signed in by looking for the lastOrderVariants input
    const lastOrderInput = document.getElementById('lastOrderVariants');
    
    // Check if customer has a subscription by looking for customer subscription data
    const customerSubscriptionElement = document.querySelector('[data-customer-subscription]');
    
    // Get the cart comparison status element
    const cartComparisonStatus = this.selector.querySelector('.cart-comparison-status');
    
    if (cartComparisonStatus) {
      // Hide the cart comparison status if customer is not signed in or doesn't have a subscription
      if (!lastOrderInput || !customerSubscriptionElement || !customerSubscriptionElement.getAttribute('data-customer-subscription')) {
        cartComparisonStatus.style.display = 'none';
      } else {
        cartComparisonStatus.style.display = 'block';
      }
    }
  }
  
  loadSavedSelections() {
    const savedDate = localStorage.getItem('selectedDeliveryDate');
    const savedFrequency = localStorage.getItem('selectedDeliveryFrequency');
    
    if (savedDate) {
      this.selectedDate = new Date(savedDate);
    }
    
    // Always force onetime frequency for now as we hid the selection step
    this.selectedFrequency = 'onetime';
    
    // Set current step based on saved selections
    if (this.selectedDate) {
      // Stay on step 1 but with date selected
      this.currentStep = 1;
    }
    
    console.log('Loaded saved selections:', { date: this.selectedDate, frequency: this.selectedFrequency });
  }
  
  isSundayAckFlow() {
    return this.orderTypeFlowEnabled && !!this.sundayAckEl;
  }

  /** Next deliverable Sunday (local time); rolls to next week after Thu 23:59 cutoff. */
  getClosestSundayDeliveryDate() {
    const now = new Date();
    const candidate = new Date(now.getFullYear(), now.getMonth(), now.getDate());
    const day = candidate.getDay();

    if (day !== 0) {
      candidate.setDate(candidate.getDate() + (7 - day));
    }

    // Orders for this Sunday close on Thursday 23:59 before it. Past cutoff
    // (i.e. Fri/Sat/Sun-after-Thu) → roll forward to the next Sunday.
    if (now >= this.getSundayOrderCutoffDateTime(candidate)) {
      candidate.setDate(candidate.getDate() + 7);
    }
// One-time delivery: 13/09/2026 -> 11/09/2026
if (
  candidate.getFullYear() === 2026 &&
  candidate.getMonth() === 8 &&
  candidate.getDate() === 13
) {
  candidate.setDate(candidate.getDate() - 2);
}
    return candidate;
  }

  updateClosestSundayAck() {
    if (!this.isSundayAckFlow()) return;

    const dateEl = this.selector.querySelector('[data-closest-sunday-date]');
    const sunday = this.getClosestSundayDeliveryDate();
    this._closestSundayDate = sunday;
const bodyDefault = this.selector.querySelector('[data-sunday-ack-body-default]');

if (
  bodyDefault &&
  sunday.getFullYear() === 2026 &&
  sunday.getMonth() === 8 &&
  sunday.getDate() === 11
) {
  bodyDefault.childNodes.forEach((node) => {
    if (node.nodeType === Node.TEXT_NODE) {
      node.textContent = node.textContent.replace('ביום ראשון הקרוב', 'ביום שישי הקרוב');
    }
  });
}
    if (dateEl) {
      dateEl.textContent = this.formatDate(sunday);
    }

    const confirmBtns = this.selector.querySelectorAll('[data-action="confirm"], .checkout-btn-new');
    confirmBtns.forEach((btn) => {
      btn.disabled = false;
      btn.classList.remove('disabled');
    });
  }

  applyClosestSundayAsSelectedDate() {
    const sunday = this._closestSundayDate || this.getClosestSundayDeliveryDate();
    this._closestSundayDate = sunday;
    this.selectedDate = sunday;
    localStorage.setItem('selectedDeliveryDate', sunday.toISOString());
    localStorage.setItem('tempSelectedDate', sunday.toISOString());

    const dateStep = this.selector.querySelector('[data-step="1"], .stepper-step[data-step="1"]');
    if (dateStep) dateStep.classList.add('completed');

    const connector = this.selector.querySelector('.step-connector, .stepper-connector');
    if (connector) connector.classList.add('active');
  }

  generateDateOptions() {
    if (this.isSundayAckFlow()) {
      this.updateClosestSundayAck();
      return;
    }

    const dateOptions =
      this.dateOptions ||
      this.selector.querySelector('#dateOptions, .date-grid-new');
    if (!dateOptions) {
      return;
    }

    const hasOneTimeItems = this.hasOneTimeDeliveryTag();

    // Clear existing options
    dateOptions.innerHTML = '';

    const now = new Date();
    
    // Get delivery days settings
    const deliveryDays = window.deliverySettings?.deliveryDays || {
      sunday: true,
      monday: false,
      tuesday: false,
      wednesday: false,
      thursday: false,
      friday: false,
      saturday: true
    };
    
    const hasOutOfStockItems = this.checkCartForOutOfStockItems();

    let nextAvailableDate = null;
    if (hasOutOfStockItems) {
      nextAvailableDate = this.getNextAvailableDeliveryDate();
    }
    
    // Find the closest delivery day
    let closestDeliveryDay = null;
    let daysUntilClosestDelivery = 30;
    
    for (let i = 0; i < 30; i++) {
      const checkDate = new Date(now);
      checkDate.setDate(checkDate.getDate() + i);
      const dayName = this.getDayName(checkDate).toLowerCase();
      
      // Check if this is a one-time delivery date or a regular delivery day
      if (this.isOneTimeDate(checkDate) || (deliveryDays[dayName] && !this.isBlackoutDate(checkDate))) {
        // Check if this day is past the cutoff time
        if (i === 0) {
          if (dayName === 'sunday') {
            if (now >= this.getSundayOrderCutoffDateTime(checkDate)) {
              continue;
            }
          } else {
            const cutoffHour = this.getCutoffHour(dayName);
            const currentHour = now.getHours();
            if (currentHour >= cutoffHour) {
              continue;
            }
          }
        }
        
        
        closestDeliveryDay = checkDate;
        daysUntilClosestDelivery = i;
        break;
      }
    }

    // Generate date options for the next 14 days (limit to 4 for the 2x2 grid)
    let deliveryDatesFound = 0;
    const maxDeliveryDates = 4;
    
    for (let i = 0; i < 32; i++) { // Look ahead up to 30 days to find 6 delivery dates
      if (deliveryDatesFound >= maxDeliveryDates) {
        break; // Stop once we've found enough delivery dates
      }
      
      const date = new Date(now);
      date.setDate(date.getDate() + i);

      // Get day name
      const dayName = this.getDayName(date).toLowerCase();
    //  console.log(`Day name: ${dayName}`);
      
      // Check if this is a one-time delivery date
      const isOneTimeDelivery = this.isOneTimeDate(date);
      
      // If we have items with one-time delivery tag, only show one-time delivery dates
      if (hasOneTimeItems && !isOneTimeDelivery) {
        //console.log(`Skipping ${date} - not a one-time delivery date and cart has one-time items`);
        continue;
      }
      
      // Skip days that don't have delivery and aren't one-time dates
      if (!isOneTimeDelivery && !deliveryDays[dayName]) {
     //   console.log(`Skipping ${dayName} - not a delivery day`);
        continue;
      }
      
      // Determine if this date should be disabled
      let isDisabled = false;
      let disableReason = "";
      let isSpecialDate = isOneTimeDelivery;

      {
        // Get delivery time for this day (e.g., "10:00 AM")
        const deliveryTimeStr = window.deliverySettings?.deliveryTimes?.[dayName] || "10:00 AM";
        let [time, ampm] = deliveryTimeStr.split(' ');
        let [deliveryHour, deliveryMinute] = time.split(':').map(Number);
        if (ampm && ampm.toUpperCase() === "PM" && deliveryHour < 12) deliveryHour += 12;
        if (ampm && ampm.toUpperCase() === "AM" && deliveryHour === 12) deliveryHour = 0;
      
        // Get cutoff in hours for this day
        const cutoffHours = window.deliverySettings?.cutoffHours?.[dayName] || 1;
      
        // Build the delivery datetime for this date
        const deliveryDateTime = new Date(date);
        deliveryDateTime.setHours(deliveryHour, deliveryMinute, 0, 0);
      
        // Calculate the cutoff datetime (Sunday: Thursday 23:59 local; other days: hours before delivery)
        let cutoffDateTime;
        if (dayName === 'sunday') {
          cutoffDateTime = this.getSundayOrderCutoffDateTime(date);
        } else {
          cutoffDateTime = new Date(deliveryDateTime.getTime() - cutoffHours * 60 * 60 * 1000);
        }
      
        // Log current time, delivery time, cutoff time, and hours left
        const nowTime = new Date();

        if (nowTime >= cutoffDateTime) {
          isDisabled = true;
          disableReason = "past cutoff";
        }
      }
      
      // Check if this date is past the cutoff time for today
      if (i === 0) {
        if (dayName === 'sunday') {
          if (now >= this.getSundayOrderCutoffDateTime(date)) {
            console.log('Disabling today - past Sunday order cutoff (Thu 23:59)');
            isDisabled = true;
            disableReason = "past cutoff";
          }
        } else {
          const cutoffHour = this.getCutoffHour(dayName);
          const currentHour = now.getHours();
          if (currentHour >= cutoffHour) {
            isDisabled = true;
            disableReason = "past cutoff";
          }
        }
      }
      
      // Check if this date is a blackout date, but only if it's not a one-time delivery date
      // Note: We're ensuring one-time delivery dates take priority over blackout dates
      if (!isDisabled && !isOneTimeDelivery && this.isBlackoutDate(date)) {
        isDisabled = true;
        disableReason = "blackout date";
      }
      
      // Special case for dates that are both blackout and one-time delivery
      if (isOneTimeDelivery && this.isBlackoutDate(date)) {
        // Ensure it's not disabled
        isDisabled = false;
        disableReason = "";
      }
      
      // For out-of-stock items, implement the special logic:
      // If there's an out-of-stock item, we need to skip the closest delivery day
      // and show the next one if the closest is <= 6 days away
      if (hasOutOfStockItems && !isDisabled) {
        if (closestDeliveryDay && daysUntilClosestDelivery <= 6) {
          // If this is the closest delivery day, disable it
          if (this.isSameDay(date, closestDeliveryDay)) {
            isDisabled = true;
            disableReason = "out of stock - skipping closest";
          }
        }
        
        // Also check against the next available date from the badge
        if (nextAvailableDate) {
          const dateWithoutTime = new Date(date.getFullYear(), date.getMonth(), date.getDate());
          const nextAvailableDateWithoutTime = new Date(
            nextAvailableDate.getFullYear(), 
            nextAvailableDate.getMonth(), 
            nextAvailableDate.getDate()
          );
          
          if (dateWithoutTime < nextAvailableDateWithoutTime) {
            isDisabled = true;
            disableReason = "before next available date";
          }
        }
      }
      
      // Skip adding more date options if we've already found enough delivery dates
      if (deliveryDatesFound >= maxDeliveryDates && !isDisabled) {
        continue;
      }
      
      // Create the date card (new design)
      const dateCard = document.createElement('div');
      dateCard.className = `date-card-new${isDisabled ? ' disabled' : ''}`;
      
      // Add specific class for blackout dates for additional styling
      if (disableReason === "blackout date") {
        dateCard.classList.add('blackout-date');
      }
      
      // Add specific class for one-time dates
      if (isSpecialDate) {
        dateCard.classList.add('one-time-date');
      }
      
      dateCard.dataset.date = date.toISOString();
      if (disableReason) {
        dateCard.dataset.disableReason = disableReason;
      }
      if (isSpecialDate) {
        dateCard.dataset.specialDate = 'one-time';
      }
      
      // Format the date display
      const dayOfWeek = this.getDayNameHebrew(date);
      const formattedDate = this.formatDate(date);
      
      // Check if this is a Sunday (day 0)
      const isSunday = date.getDay() === 0;
      
      // Check if this is the first/closest date
      const isClosest = deliveryDatesFound === 0 && !isDisabled;
      
      // Create the HTML for the date card
      let dateCardHTML = `
        <div class="date-day">${dayOfWeek}</div>
        <div class="date-number">${formattedDate}</div>
      `;
      
      // Add "Closest" badge for the first available date
      if (isClosest) {
        dateCardHTML += `<div class="date-badge">הכי קרוב</div>`;
      }
      
      dateCard.innerHTML = dateCardHTML;
      
      // Add click handler if not disabled
      if (!isDisabled) {
        dateCard.addEventListener('click', () => this.selectDate(date));
      }

      dateOptions.appendChild(dateCard);
      
      // Only count enabled delivery dates
      if (!isDisabled) {
        deliveryDatesFound++;
        
        // If we've reached our desired number of delivery dates, break out of the loop
        if (deliveryDatesFound >= maxDeliveryDates) {
          break;
        }
      }
    }

    if (hasOneTimeItems) {
      const existingMessage = this.selector.querySelector('.one-time-delivery-message');
      if (!existingMessage) {
        // Create a message container
        const messageContainer = document.createElement('div');
        messageContainer.className = 'one-time-delivery-message';
        messageContainer.innerHTML = '<p>מוצג זמן אספקה מיוחד עבור המוצרים שבעגלה</p>'; // "Special delivery time shown for cart items"
        messageContainer.style.textAlign = 'center';
        messageContainer.style.marginTop = '10px';
        messageContainer.style.padding = '8px';
        messageContainer.style.backgroundColor = '#e6f7ff';
        messageContainer.style.borderRadius = '6px';
        messageContainer.style.fontSize = '14px';
        messageContainer.style.color = '#0066cc';
        
        // Insert after the date options
        const dateOptionsContainer = dateOptions.parentNode;
        if (dateOptionsContainer) {
          dateOptionsContainer.insertBefore(messageContainer, dateOptions.nextSibling);
        }
      }
    } else {
      const existingMessage = this.selector.querySelector('.one-time-delivery-message');
      if (existingMessage) {
        existingMessage.remove();
      }
    }
  }

  /** Coalesce rapid cart events + delivery-dates-reload (avoid double DOM rebuild). */
  scheduleGenerateDateOptions() {
    if (this._genDateDebounce) clearTimeout(this._genDateDebounce);
    this._genDateDebounce = setTimeout(() => {
      this._genDateDebounce = null;
      this.generateDateOptions();
    }, 100);
  }

  getNextDayOfWeek(date, dayOfWeek, weekOffset = 0) {
    const resultDate = new Date(date.getTime());
    resultDate.setDate(date.getDate() + (7 + dayOfWeek - date.getDay()) % 7 + (weekOffset * 7));
    return resultDate;
  }
  
  isSameDay(date1, date2) {
    return date1.getDate() === date2.getDate() &&
           date1.getMonth() === date2.getMonth() &&
           date1.getFullYear() === date2.getFullYear();
  }
  
  getDayName(date) {
    const days = ['sunday', 'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday'];
    const dayName = days[date.getDay()];
    //console.log(`Getting day name for ${date}: ${dayName}`);
    return dayName;
  }
  
  formatDate(date) {
    const day = date.getDate().toString().padStart(2, '0');
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    return `${day}/${month}`;
  }

  parseNumericMoneyFromText(text) {
    const n = parseFloat(String(text || '').replace(/[^\d.]/g, ''));
    return Number.isFinite(n) ? n : 0;
  }

  /** Display amounts like ₪508 or ₪50.80 (matches storefront Hebrew pricing). */
  formatMoneyIls(amount) {
    const rounded = Math.round(amount * 100) / 100;
    const showDecimals = Math.abs(rounded % 1) > 0.001;
    const num = showDecimals ? rounded.toFixed(2) : String(Math.round(rounded));
    return `₪${num}`;
  }

  otpOrderTypeTpl(tpl, vars) {
    if (!tpl || !vars) return tpl || '';
    return tpl.replace(/\{(\w+)\}/g, (_, k) => (vars[k] != null ? String(vars[k]) : ''));
  }

  getOrderTypeCartBaseAmount() {
    const fromEl = this.totalAmountElement ? this.totalAmountElement.textContent : '';
    const fromDom = this.parseNumericMoneyFromText(fromEl);
    if (fromDom > 0) return fromDom;
    const fromField = parseFloat(String(this.cartTotal || '').replace(',', '.'));
    return Number.isFinite(fromField) && fromField > 0 ? fromField : 0;
  }

  _scheduleDrawerCartSync() {
    if (this._cartJsFetchDebounce) clearTimeout(this._cartJsFetchDebounce);
    this._cartJsFetchDebounce = setTimeout(() => {
      this._cartJsFetchDebounce = null;
      fetch(shopifyCartJsonPath('cart.js'), { credentials: 'same-origin' })
        .then((r) => r.json())
        .then((cart) => {
          const cartForm = document.getElementById('AjaxCartForm');
          const cartTotalElement = cartForm
            ? cartForm.querySelector('[data-cart-total]')
            : document.querySelector('.cart__total[data-cart-total]');
          if (!cartTotalElement) {
            this.cartTotal = (cart.total_price / 100).toFixed(2);
            if (this.totalAmountElement) {
              this.totalAmountElement.textContent = this.cartTotal;
            }
          }
          if (this.orderTypeFlowEnabled) this.refreshOrderTypePanelPricing();
        })
        .catch(() => {});
    }, 120);
  }

  setCartTotal() {
    const cartForm = document.getElementById('AjaxCartForm');
    const cartTotalElement = cartForm
      ? cartForm.querySelector('[data-cart-total]')
      : document.querySelector('.cart__total[data-cart-total]');

    if (cartTotalElement) {
      const cartItemsSubtotal = cartForm
        ? cartForm.querySelector('[data-cart-items-subtotal]')
        : document.querySelector('[data-cart-items-subtotal]');

      if (cartItemsSubtotal) {
        this.cartTotal = cartItemsSubtotal.textContent.trim().replace('₪', '');
      } else {
        this.cartTotal = cartTotalElement.textContent.trim().replace('₪', '');
      }
      if (this.totalAmountElement) {
        this.totalAmountElement.textContent = this.cartTotal;
      }
      if (this.orderTypeFlowEnabled) {
        this._scheduleDrawerCartSync();
        this.refreshOrderTypePanelPricing();
      }
      return;
    }

    this._scheduleDrawerCartSync();
  }
  
  /**
   * Date footer / legacy confirm: one handler, capture phase — blocks duplicate listeners from also calling checkout.
   */
  async handleConfirmOrCheckoutButtonClick(event) {
    const btn = event.target.closest && event.target.closest('[data-action="confirm"], .checkout-btn-new');
    if (!btn || !this.selector.contains(btn)) return;

    event.preventDefault();
    event.stopImmediatePropagation();
    event.stopPropagation();

    console.log(
      'Checkout button clicked',
      'frequency=' + String(this.selectedFrequency),
      'orderTypeFlowEnabled=' + String(this.orderTypeFlowEnabled),
      'orderTypePhase=' + String(this.orderTypePhase),
      'date=' + (this.selectedDate ? this.selectedDate.toISOString() : '')
    );

    if (this.isSundayAckFlow()) {
      this.applyClosestSundayAsSelectedDate();
    } else if (!this.selectedDate) {
      const selectedCard = this.selector.querySelector('.date-card-new.selected, .date-option.selected');
      if (selectedCard) {
        const dateStr = selectedCard.dataset.date;
        if (dateStr) {
          this.selectedDate = new Date(dateStr);
          console.log('Retrieved date from UI:', this.selectedDate);
        }
      }
    }

    if (!this.selectedDate) {
      this.showValidationError('date');
      return;
    }

    if (this.orderTypeFlowEnabled && this.orderTypePhase === 'date') {
      if (
        !PROMEAL_SKIP_ORDER_TYPE_STEP &&
        this.isBoostifyCardUpdateFlow() &&
        this.getBoostifyCardUpdateMealCount() >= OTP_MIN_WEEKLY_MEALS
      ) {
        this._cartMainDishCount = this.getBoostifyCardUpdateMealCount();
        this.orderTypeChoice = 'sub';
        sessionStorage.setItem('promeal_order_type_choice', 'sub');
        this.showCheckoutLoader();
        deliveryCheckoutDebugReset();
        deliveryCheckoutDebugStep('cardUpdate: date → checkout (sub)');
        try {
          await this.finalizeOrderTypeAndCheckout();
        } catch (err) {
          console.error('[Delivery] card update skip order-type', err);
          this.hideCheckoutLoader();
        }
        return;
      }
      if (PROMEAL_SKIP_ORDER_TYPE_STEP) {
        this.orderTypeChoice = 'once';
        sessionStorage.setItem('promeal_order_type_choice', 'once');
        this.showCheckoutLoader();
        deliveryCheckoutDebugReset();
        deliveryCheckoutDebugStep('skipOrderTypeStep: date → checkout (once)');
        try {
          await this.applyOrderTypeToCartLines();
          this.selectedFrequency = 'onetime';
          this.syncDeliveryFlowSteppers(3);
          await this.confirmSelection();
        } catch (err) {
          console.error('[Delivery] skip order-type step', err);
          this.hideCheckoutLoader();
        }
        return;
      }
      this.goToOrderTypeStep();
      return;
    }

    try {
      await this.confirmSelection();
    } catch (err) {
      console.error('[Delivery] confirmSelection', err);
      this.hideCheckoutLoader();
    }
  }

  initEventListeners() {
    // Close panel button (support both old and new classes)
    const closeButtons = this.selector.querySelectorAll('[data-action="close"], .close-panel-new');
    closeButtons.forEach(closeButton => {
      closeButton.addEventListener('click', () => this.closePanel());
    });
    
    // Overlay click to close
    if (this.overlay) {
      this.overlay.addEventListener('click', () => this.closePanel());
    }
    
    // Next step buttons
    const nextStepButtons = this.selector.querySelectorAll('[data-action="next-step"]');
    if (nextStepButtons) {
      nextStepButtons.forEach(button => {
        button.addEventListener('click', () => this.goToNextStep());
      });
    }
    
    // Previous step buttons
    const prevStepButtons = this.selector.querySelectorAll('[data-action="prev-step"]');
    if (prevStepButtons) {
      prevStepButtons.forEach(button => {
        button.addEventListener('click', () => this.goToPreviousStep());
      });
    }
    
    // Clickable steps (only steps 1 and 2)
    const stepsNav = this.selector.querySelectorAll('[data-action="goto-step"]');
    if (stepsNav) {
      stepsNav.forEach(step => {
        step.addEventListener('click', () => {
          const targetStep = parseInt(step.getAttribute('data-target-step'));
          this.goToStep(targetStep);
        });
      });
    }
    
    // Frequency options
    const frequencyOptions = this.selector.querySelectorAll('.frequency-option');
    frequencyOptions.forEach(option => {
      option.addEventListener('click', this.handleFrequencyClick.bind(this));
      
      // Set discount information for each frequency option
      const frequency = option.dataset.frequency;
      const discountElement = option.querySelector('.discount-info');
      
      if (discountElement && frequency) {
        discountElement.textContent = this.getDiscountInfo(frequency);
      }
    });
    
    // Single capture listener on the root so we never double-fire (same button matches two selectors, HMR, etc.)
    if (!this._confirmButtonDelegateBound) {
      this._confirmButtonDelegateBound = true;
      this.selector.addEventListener('click', (e) => this.handleConfirmOrCheckoutButtonClick(e), true);
    }
    
    // Listen for cart close events
    document.addEventListener('cart:close', () => {
      // Reset delivery date when cart is closed
      this.selectedDate = null;
      localStorage.removeItem('tempSelectedDate');
      localStorage.removeItem('selectedDeliveryDate');
    });
    
    // Step navigation
    const stepElements = this.selector.querySelectorAll('.step');
    stepElements.forEach((step, index) => {
      step.addEventListener('click', () => {
        const stepNumber = index + 1;
        
        // Only allow clicking on step 1 if we're on step 2
        if (stepNumber === 1 && this.currentStep === 2) {
          console.log('Step 1 clicked from step 2');
          // Clear validation messages before going back
          this.clearValidationMessages();
          
          // Force to step 1
          this.currentStep = 1;
          
          // Update UI
          this.updateStepUI();
          this.updateConfirmButtonText();
          this.updateButtonLayout();
          
          // Extra cleanup
          setTimeout(() => {
            this.clearValidationMessages();
          }, 50);
        }
      });
    });
    
    // Hide the back button in the step actions
    const stepActionsBackBtn = this.selector.querySelector('.step-actions .back-step-btn');
    if (stepActionsBackBtn) {
      stepActionsBackBtn.style.display = 'none';
    }
  }
  
  selectDate(date) {
    console.log("Selecting date:", date);
    this.selectedDate = date;
    
    // Store in localStorage
    localStorage.setItem('selectedDeliveryDate', date.toISOString());
    localStorage.setItem('tempSelectedDate', date.toISOString());
    
    // Update UI - support both old and new class names
    const dateCards = this.selector.querySelectorAll('.date-card-new, .date-option');
    dateCards.forEach(card => {
      card.classList.remove('selected');
      
      // Safely check if the date matches
      try {
        const dayElement = card.querySelector('.date-day');
        const dateElement = card.querySelector('.date-number');
        
        if (dayElement && dateElement) {
          const dayName = dayElement.textContent;
          const dateText = dateElement.textContent;
          const cardDate = this.parseDateFromText(dayName, dateText);
      
          if (cardDate && this.isSameDay(cardDate, date)) {
            card.classList.add('selected');
          }
        }
      } catch (e) {
        console.error("Error comparing dates:", e);
      }
    });
    
    // Enable next step button
    const nextStepBtn = this.selector.querySelector('[data-action="next-step"]');
    if (nextStepBtn) {
      nextStepBtn.disabled = false;
    }

    // Enable confirm button (new class)
    const confirmBtns = this.selector.querySelectorAll('[data-action="confirm"], .checkout-btn-new');
    if (confirmBtns) {
      confirmBtns.forEach(btn => {
        btn.disabled = false;
        btn.classList.remove('disabled');
      });
    }
    
    // Mark step as completed (support both old and new stepper)
    const dateStep = this.selector.querySelector('[data-step="1"], .stepper-step[data-step="1"]');
    if (dateStep) {
      dateStep.classList.add('completed');
    }
    
    // Update connector
    const connector = this.selector.querySelector('.step-connector, .stepper-connector');
    if (connector) {
      connector.classList.add('active');
    }
  }
  
  parseDateFromText(dayName, dateText) {
    try {
      // Parse the date from the text (format is now "dd/mm")
      const parts = dateText.trim().split('/');
      if (parts.length !== 2) return null;
      
      const day = parseInt(parts[0], 10);
      const month = parseInt(parts[1], 10) - 1; // JavaScript months are 0-indexed
      
      if (isNaN(day) || isNaN(month) || month < 0 || month > 11) {
        console.error("Invalid date parts:", parts);
        return null;
      }
      
      const year = new Date().getFullYear();
      return new Date(year, month, day);
    } catch (e) {
      console.error("Error parsing date:", e);
      return null;
    }
  }
  
  handleFrequencyClick(event) {
    const frequencyOption = event.currentTarget;
    const frequency = frequencyOption.dataset.frequency;
    
    if (!frequency) return;
    
    console.log(`Selected frequency: ${frequency}`);
    
    // Update the selected frequency
    this.selectedFrequency = frequency;
    
    // Store the selected frequency in localStorage temporarily
    localStorage.setItem('tempSelectedFrequency', frequency);
    
    // Update the UI
    const frequencyOptions = this.selector.querySelectorAll('.frequency-option');
    frequencyOptions.forEach(option => {
      option.classList.remove('selected');
    });
    
    frequencyOption.classList.add('selected');
    
    // Clear any validation messages
    this.clearValidationMessages();
    
    // Enable the confirm button
    const confirmButton = this.selector.querySelector('[data-action="confirm"]');
    if (confirmButton) {
      confirmButton.disabled = false;
    }
    
    // Update shipping labels based on frequency
    this.updateShippingLabels(frequency);
  }
  
  updateShippingLabels(frequency) {
    const freeShippingLabel = this.selector.querySelector('[data-free-shipping]');
    const paidShippingLabel = this.selector.querySelector('[data-paid-shipping]');
    const cartTotal = parseFloat(this.totalAmountElement.textContent) || 0;
    
    if (!freeShippingLabel || !paidShippingLabel) return;
    
    // Calculate discount amount if applicable
    let discountMessage = '';
    
    if (frequency === 'weekly') {
      // 10% discount
      const discountAmount = cartTotal * 0.1;
      discountMessage = ` 🎉 10% הנחה (₪${discountAmount.toFixed(0)}) על ההזמנה הבאה`;
    } else if (frequency === 'biweekly') {
      // 5% discount
      const discountAmount = cartTotal * 0.05;
      discountMessage = ` 🎉 5% הנחה (₪${discountAmount.toFixed(0)}) על ההזמנה הבאה`;
    } else if (frequency === 'monthly') {
      // Surprise gift
      discountMessage = ' 🎉 הפתעה טעימה בהזמנה הבאה';
    } else if (frequency === 'onetime') {
      // Free shipping
      discountMessage = 'יהיה טעים';
    }
    
    // If there's a currently visible label, just fade it out
    if (!freeShippingLabel.classList.contains('hidden')) {
      // Add the fade-out animation
      freeShippingLabel.classList.add('shipping-label-animate-out');
      
      // After the fade-out animation completes, update the content and slide in
      setTimeout(() => {
        // Update the content
        freeShippingLabel.textContent = discountMessage;
        
        // Remove the fade-out animation
        freeShippingLabel.classList.remove('shipping-label-animate-out');
        
        // Force a reflow
        void freeShippingLabel.offsetWidth;
        
        // Add the slide-in animation
        freeShippingLabel.classList.add('shipping-label-animate-in');
        
        // Make sure it's visible
        freeShippingLabel.classList.remove('hidden');
      }, 200); // Match this to the fade-out animation duration
    } else {
      // No visible label, just update and slide in
      // Update the content
      freeShippingLabel.textContent = discountMessage;
      
      // Remove any existing animations
      freeShippingLabel.classList.remove('shipping-label-animate-out');
      freeShippingLabel.classList.remove('shipping-label-animate-in');
      
      // Make sure it's visible but off-screen
      freeShippingLabel.classList.remove('hidden');
      freeShippingLabel.style.transform = 'translateX(-100%)';
      freeShippingLabel.style.opacity = '0';
      
      // Force a reflow
      void freeShippingLabel.offsetWidth;
      
      // Add the slide-in animation
      freeShippingLabel.classList.add('shipping-label-animate-in');
    }
    
    // Hide the paid shipping label
    paidShippingLabel.classList.add('hidden');
  }
  
  goToNextStep() {
    // Always validate date selection before proceeding
    if (this.currentStep === 1 && !this.selectedDate) {
      this.showValidationError('date');
      return; // Don't proceed if no date is selected
    }
    
    if (this.currentStep < 2) {
      this.currentStep++;
      
      // Update the UI
      this.updateStepUI();
      
      // Enable/disable the confirm button based on step
      const confirmButton = this.selector.querySelector('[data-action="confirm"]');
      if (confirmButton) {
        if (this.currentStep === 1) {
          // Always enable on first step
          confirmButton.disabled = false;
          confirmButton.classList.remove('disabled');
        } else if (this.currentStep === 2) {
          // On second step, only enable if frequency is selected
          confirmButton.disabled = !this.selectedFrequency;
          if (!this.selectedFrequency) {
            confirmButton.classList.add('disabled');
          } else {
            confirmButton.classList.remove('disabled');
          }
        }
      }
    }
    
    // Update the confirm button text
    this.updateConfirmButtonText();
    
    // Update the button layout
    this.updateButtonLayout();
  }
  
  goToPreviousStep() {
    console.log('goToPreviousStep called');
    
    if (this.currentStep > 1) {
      // Clear validation messages before changing steps
      this.clearValidationMessages();
      
      // Set the current step
      this.currentStep = 1; // Force to step 1 since we only have 2 steps
      
      // Update the UI
      this.updateStepUI();
      
      // Update the confirm button text
      this.updateConfirmButtonText();
      
      // Update the button layout
      this.updateButtonLayout();
      
      // Make sure validation messages are cleared after UI update
      setTimeout(() => {
        this.clearValidationMessages();
        
        // Also clear any validation styling
        const dateOptions = this.selector.querySelector('.date-options');
        if (dateOptions) {
          dateOptions.classList.remove('validation-error');
        }
        
        const frequencyOptions = this.selector.querySelector('.frequency-options');
        if (frequencyOptions) {
          frequencyOptions.classList.remove('validation-error');
        }
      }, 50);
    }
  }
  
  goToStep(step) {
    // Only allow going to steps 1 and 2
    if (step <= 2 && (step < this.currentStep || (step === 2 && this.selectedDate))) {
      this.currentStep = step;
      this.updateStepUI();
    }
  }
  
  updateStepUI() {
    // Update step indicators
    const steps = this.selector.querySelectorAll('.step');
    steps.forEach(step => {
      const stepNumber = parseInt(step.getAttribute('data-step'));
      step.classList.remove('active', 'completed');
      if (stepNumber === this.currentStep) {
        step.classList.add('active');
      } else if (stepNumber < this.currentStep) {
        step.classList.add('completed');
      }
    });
    
    // Update step connectors
    const connectors = this.selector.querySelectorAll('.step-connector');
    connectors.forEach((connector, index) => {
      connector.classList.remove('active');
      if (index < this.currentStep - 1) {
        connector.classList.add('active');
      }
    });
    
    // Update step content visibility
    const stepContents = this.selector.querySelectorAll('[data-step-content]');
    stepContents.forEach(content => {
      const contentStep = parseInt(content.getAttribute('data-step-content'));
      content.classList.add('hidden');
      if (contentStep === this.currentStep) {
        content.classList.remove('hidden');
      }
    });
    
    // Update step titles
    const stepTitle1 = this.selector.querySelector('[data-title-step-1]');
    const stepTitle2 = this.selector.querySelector('[data-title-step-2]');
    
    if (stepTitle1 && stepTitle2) {
      stepTitle1.classList.add('hidden');
      stepTitle2.classList.add('hidden');
      
      if (this.currentStep === 1) {
        stepTitle1.classList.remove('hidden');
      } else if (this.currentStep === 2) {
        stepTitle2.classList.remove('hidden');
      }
    }
    
    // Update next step button state
    if (this.currentStep === 1) {
      const nextStepBtn = this.selector.querySelector('[data-action="next-step"]');
      if (nextStepBtn) {
        nextStepBtn.disabled = !this.selectedDate;
      }
    }
    
    // Update back button visibility

  }

  getBoostifyCardUpdateMealCount() {
    try {
      const n = parseInt(sessionStorage.getItem('promeal_boostify_card_update_meal_count'), 10);
      return Number.isFinite(n) && n > 0 ? n : 0;
    } catch (e) {
      return 0;
    }
  }

  isBoostifyCardUpdateFlow() {
    try {
      return sessionStorage.getItem('promeal_boostify_card_update') === '1';
    } catch (e) {
      return false;
    }
  }

  isWeeklySubscriptionEligible() {
    if (this.isBoostifyCardUpdateFlow()) {
      const stored = this.getBoostifyCardUpdateMealCount();
      if (stored >= OTP_MIN_WEEKLY_MEALS) return true;
    }
    const count = this._cartMainDishCount;
    return typeof count === 'number' && count >= OTP_MIN_WEEKLY_MEALS;
  }

  countMealsInBundleProperty(raw) {
    if (!raw) return 0;
    try {
      const arr = typeof raw === 'string' ? JSON.parse(raw) : raw;
      if (!Array.isArray(arr)) return 0;
      return arr.reduce((sum, bi) => {
        const q = Number(bi && bi.quantity);
        return sum + (Number.isFinite(q) && q > 0 ? q : 1);
      }, 0);
    } catch (e) {
      return 0;
    }
  }

  countMealsFromVariantsData(raw) {
    if (!raw) return 0;
    try {
      const vd = typeof raw === 'string' ? JSON.parse(raw) : raw;
      if (!vd || !vd.variants) return 0;
      return String(vd.variants)
        .split(',')
        .reduce((sum, pair) => {
          const q = parseInt(String(pair).split(':')[1], 10);
          return sum + (Number.isFinite(q) && q > 0 ? q : 0);
        }, 0);
    } catch (e) {
      return 0;
    }
  }

  countMainDishesFromCart(cart) {
    if (!cart || !Array.isArray(cart.items)) return 0;
    let count = 0;
    for (const item of cart.items) {
      const props = item.properties || {};
      const qty = Number(item.quantity) > 0 ? Number(item.quantity) : 1;

      const fixedBoxMeals = fixedBoxMealCountForLineItem(item);
      if (fixedBoxMeals != null) {
        count += fixedBoxMeals * qty;
        continue;
      }

      const stamped = parseInt(props._main_dish_count, 10);
      if (Number.isFinite(stamped) && stamped > 0) {
        count += stamped * qty;
        continue;
      }

      const fromVariants = this.countMealsFromVariantsData(props._variants_data);
      if (fromVariants > 0) {
        count += fromVariants * qty;
        continue;
      }

      if (props._bundle_items) {
        count += this.countMealsInBundleProperty(props._bundle_items) * qty;
      }
    }
    return count;
  }

  readMainDishCountFromDom() {
    const el =
      document.querySelector('#AjaxCartSubtotal [data-bulk-main-dish-count]') ||
      document.querySelector('[data-bulk-main-dish-count]');
    if (!el) return null;
    const n = parseInt(el.getAttribute('data-bulk-main-dish-count'), 10);
    return Number.isFinite(n) ? n : null;
  }

  async fetchMainDishCountFromSection() {
    try {
      const url = `${shopifyCartJsonPath('?section_id=helper-cart')}&_=${Date.now()}`;
      const html = await fetch(url, { credentials: 'same-origin', cache: 'no-store' }).then((r) => r.text());
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const el = doc.querySelector('[data-bulk-main-dish-count]');
      if (!el) return null;
      const n = parseInt(el.getAttribute('data-bulk-main-dish-count'), 10);
      return Number.isFinite(n) ? n : null;
    } catch (e) {
      return null;
    }
  }

  resolveCartMainDishCount(cart, sectionCount) {
    const fromDom = this.readMainDishCountFromDom();
    const fromSection = typeof sectionCount === 'number' ? sectionCount : null;
    const fromCart = this.countMainDishesFromCart(cart);
    const fromCardUpdate = this.isBoostifyCardUpdateFlow()
      ? this.getBoostifyCardUpdateMealCount()
      : null;
    const candidates = [fromDom, fromSection, fromCart, fromCardUpdate].filter(
      (n) => typeof n === 'number' && n >= 0
    );
    return candidates.length ? Math.max(...candidates) : 0;
  }

  async fetchCartMainDishCount(cart) {
    const fromSection = await this.fetchMainDishCountFromSection();
    return this.resolveCartMainDishCount(cart, fromSection);
  }

  applyOrderTypeMinMealsState() {
    if (!this.orderTypePanel) return;
    const eligible = this.isWeeklySubscriptionEligible();
    const subBtn = this.orderTypePanel.querySelector('[data-order-type-choice="sub"]');
    const minHint = this.orderTypePanel.querySelector('[data-otp-sub-min-hint]');
    const saveBlock = this.orderTypePanel.querySelector('[data-otp-sub-save-block]');
    const s = window.themeOrderTypeStrings || {};

    if (subBtn) {
      subBtn.classList.toggle('otp-card--disabled', !eligible);
      subBtn.setAttribute('aria-disabled', !eligible ? 'true' : 'false');
      if (!eligible) {
        subBtn.tabIndex = -1;
      } else {
        subBtn.removeAttribute('tabindex');
      }
    }
    if (minHint) {
      minHint.classList.toggle('otp-min-hint--show', !eligible);
      minHint.setAttribute('aria-hidden', eligible ? 'true' : 'false');
      if (!eligible) {
        const titleEl = minHint.querySelector('[data-otp-sub-min-title]');
        const gap = Math.max(0, OTP_MIN_WEEKLY_MEALS - (this._cartMainDishCount || 0));
        if (titleEl) {
          if (gap === 1 && s.sub_min_banner_one) {
            titleEl.textContent = s.sub_min_banner_one;
          } else if (s.sub_min_banner_fmt) {
            titleEl.textContent = this.otpOrderTypeTpl(s.sub_min_banner_fmt, { count: String(gap) });
          }
        }
      }
    }
    if (saveBlock) {
      saveBlock.classList.toggle('otp-sub-save-block--show', eligible);
      saveBlock.setAttribute('aria-hidden', eligible ? 'false' : 'true');
    }
  }

  async refreshOrderTypeMealEligibility(cart) {
    if (!this.orderTypeFlowEnabled || this.orderTypePhase !== 'order_type') return;
    const mainDishCount = await this.fetchCartMainDishCount(cart || null);
    this._cartMainDishCount = mainDishCount;
    this.setDefaultOrderTypeChoice();
    this.applyOrderTypeMinMealsState();
    this.applyOrderTypeChoiceToCards();
  }

  setDefaultOrderTypeChoice() {
    if (PROMEAL_SKIP_ORDER_TYPE_STEP) {
      this.orderTypeChoice = 'once';
      sessionStorage.setItem('promeal_order_type_choice', 'once');
      return;
    }
    let cardUpdate = false;
    try {
      cardUpdate = sessionStorage.getItem('promeal_boostify_card_update') === '1';
    } catch (e) {
      cardUpdate = false;
    }
    if (cardUpdate && this.isWeeklySubscriptionEligible()) {
      this.orderTypeChoice = 'sub';
      sessionStorage.setItem('promeal_order_type_choice', 'sub');
      return;
    }
    const choice = this.isWeeklySubscriptionEligible()
      ? PROMEAL_DEFAULT_ORDER_TYPE_CHOICE
      : 'once';
    this.orderTypeChoice = choice;
    sessionStorage.setItem('promeal_order_type_choice', choice);
  }

  goToOrderTypeStep() {
    if (PROMEAL_SKIP_ORDER_TYPE_STEP) return;
    if (!this.orderTypeFlowEnabled || !this.orderTypePanel || !this.panel) return;
    this._customerSubsCache = undefined;
    this._fullOrderPlansCache = undefined;
    this._cartMainDishCount = undefined;
    this.orderTypePhase = 'order_type';
    this.panel.classList.remove('show');
    this.orderTypePanel.classList.add('show');
    this.orderTypePanel.removeAttribute('hidden');
    this.syncDeliveryFlowSteppers(2);
    fetch(shopifyCartJsonPath('cart.js'), { credentials: 'same-origin' })
      .then((r) => r.json())
      .then(async (cart) => {
        const mainDishCount = await this.fetchCartMainDishCount(cart);
        this._cartMainDishCount = mainDishCount;
        const tp = (cart.total_price || 0) / 100;
        this.cartTotal = tp.toFixed(2);
        if (this.totalAmountElement) this.totalAmountElement.textContent = this.cartTotal;
        this.setDefaultOrderTypeChoice();
        this.applyOrderTypeMinMealsState();
        this.applyOrderTypeChoiceToCards();
        this.refreshOrderTypePanelPricing();
        this.dispatchOrderTypeAnalytics('view_order_type_step', {
          choice: this.orderTypeChoice,
          main_dish_count: mainDishCount,
        });
      })
      .catch(() => {
        this.fetchCartMainDishCount(null).then((mainDishCount) => {
          this._cartMainDishCount = mainDishCount;
          this.setDefaultOrderTypeChoice();
          this.applyOrderTypeMinMealsState();
          this.applyOrderTypeChoiceToCards();
          this.refreshOrderTypePanelPricing();
          this.dispatchOrderTypeAnalytics('view_order_type_step', { choice: this.orderTypeChoice });
        });
      });
    this.bindOrderTypePanelEventsOnce();
    this.warmCheckoutCachesForOrderType();
  }

  goBackToDateFromOrderType() {
    if (!this.orderTypeFlowEnabled || !this.orderTypePanel || !this.panel) return;
    this.orderTypePhase = 'date';
    this.orderTypePanel.classList.remove('show');
    this.panel.classList.add('show');
    this.syncDeliveryFlowSteppers(1);
  }

  syncDeliveryFlowSteppers(activeStep) {
    const skipOt = PROMEAL_SKIP_ORDER_TYPE_STEP && this.orderTypeFlowEnabled;
    const flowStep = skipOt ? (activeStep >= 2 ? 2 : 1) : activeStep;
    const syncRow = (root) => {
      if (!root) return;
      const steps = root.querySelectorAll('[data-step]');
      const maxN = steps.length;
      if (!maxN) return;
      const visualStep = skipOt
        ? Math.min(Math.max(flowStep, 1), 2)
        : Math.min(Math.max(activeStep, 1), maxN);
      steps.forEach((el) => {
        const phase = el.getAttribute('data-step-phase');
        if (skipOt && phase === 'order_type') return;
        let n = parseInt(el.getAttribute('data-step'), 10);
        if (skipOt && phase === 'checkout') n = 2;
        else if (skipOt && phase === 'date') n = 1;
        el.classList.remove('active', 'completed');
        if (n < visualStep) el.classList.add('completed');
        else if (n === visualStep) el.classList.add('active');
      });
      root.querySelectorAll('[data-step-conn]').forEach((conn) => {
        const n = parseInt(conn.getAttribute('data-step-conn'), 10);
        if (skipOt && n === 1) return;
        const active = skipOt && n === 2 ? visualStep >= 2 : n < visualStep;
        conn.classList.toggle('active', active);
      });
    };
    const three = this.selector.querySelector('.stepper-new--three');
    const two = this.selector.querySelector('.stepper-new:not(.stepper-new--three)');
    syncRow(three || two);
    if (!this.orderTypeFlowEnabled || !this.orderTypePanel) return;
    const otpInd = this.orderTypePanel.querySelector('[data-otp-step-indicator]');
    if (!otpInd) return;
    otpInd.querySelectorAll('[data-otp-step]').forEach((el) => {
      const n = parseInt(el.getAttribute('data-otp-step'), 10);
      el.classList.remove('otp-step--active', 'otp-step--done', 'otp-step--todo');
      if (n < activeStep) el.classList.add('otp-step--done');
      else if (n === activeStep) el.classList.add('otp-step--active');
      else el.classList.add('otp-step--todo');
    });
    otpInd.querySelectorAll('[data-otp-conn]').forEach((conn) => {
      const n = parseInt(conn.getAttribute('data-otp-conn'), 10);
      conn.classList.toggle('otp-conn--done', n < activeStep);
    });
  }

  refreshOrderTypePanelPricing() {
    if (!this.orderTypePanel) return;
    const s = window.themeOrderTypeStrings || {};
    const base = this.getOrderTypeCartBaseAmount();
    const payStr = base > 0 ? this.formatMoneyIls(base) : '—';
    const discWeek = base * OTP_SUB_WEEKLY_DISCOUNT_RATE;
    const nextWeek = base * (1 - OTP_SUB_WEEKLY_DISCOUNT_RATE);
    const monthlySave = discWeek * OTP_EST_WEEKS_PER_MONTH;

    const pillNow = this.orderTypePanel.querySelector('[data-otp-sub-pill-now]');
    const pillNext = this.orderTypePanel.querySelector('[data-otp-sub-pill-next]');
    if (pillNow) {
      pillNow.textContent =
        base > 0 && s.sub_price_first_fmt
          ? this.otpOrderTypeTpl(s.sub_price_first_fmt, { amount: payStr })
          : '—';
    }
    if (pillNext) {
      pillNext.textContent =
        base > 0 && s.sub_price_then_fmt
          ? this.otpOrderTypeTpl(s.sub_price_then_fmt, { amount: this.formatMoneyIls(nextWeek) })
          : '—';
    }

    const onceEl = this.orderTypePanel.querySelector('[data-otp-once-price]');
    if (onceEl) {
      onceEl.textContent =
        base > 0 && s.once_price_fmt ? this.otpOrderTypeTpl(s.once_price_fmt, { amount: payStr }) : '—';
    }

    const saveTitle = this.orderTypePanel.querySelector('[data-otp-save-title]');
    const saveSub = this.orderTypePanel.querySelector('[data-otp-save-sub]');
    if (saveTitle) {
      saveTitle.textContent =
        base > 0 && s.save_title_fmt
          ? this.otpOrderTypeTpl(s.save_title_fmt, { amount: this.formatMoneyIls(monthlySave) })
          : '—';
    }
    if (saveSub && s.save_subtitle) saveSub.textContent = s.save_subtitle;

    this.applyOrderTypeMinMealsState();

    const foot = this.orderTypePanel.querySelector('[data-otp-foot-total]');
    if (foot) {
      if (this.orderTypeChoice === 'sub' || this.orderTypeChoice === 'once') {
        foot.textContent = base > 0 ? payStr : '—';
      } else {
        foot.textContent = '—';
      }
    }
  }

  applyOrderTypeChoiceToCards() {
    if (!this.orderTypePanel) return;
    if (this.orderTypeChoice === 'sub' && !this.isWeeklySubscriptionEligible()) {
      this.orderTypeChoice = 'once';
      sessionStorage.setItem('promeal_order_type_choice', 'once');
    }
    const subBtn = this.orderTypePanel.querySelector('[data-order-type-choice="sub"]');
    const onceBtn = this.orderTypePanel.querySelector('[data-order-type-choice="once"]');
    const cta = this.orderTypePanel.querySelector('[data-order-type-confirm]');
    const ctaLabel = this.orderTypePanel.querySelector('[data-otp-cta-label]');
    if (subBtn && onceBtn) {
      const isSub = this.orderTypeChoice === 'sub' && this.isWeeklySubscriptionEligible();
      subBtn.classList.toggle('otp-card--selected', isSub);
      subBtn.classList.toggle('otp-card--filled', isSub);
      subBtn.setAttribute('aria-pressed', isSub ? 'true' : 'false');
      onceBtn.classList.toggle('otp-card--selected', !isSub);
      onceBtn.classList.toggle('otp-card--filled', false);
      onceBtn.setAttribute('aria-pressed', !isSub ? 'true' : 'false');
    }
    if (cta && ctaLabel) {
      const has = this.orderTypeChoice === 'sub' || this.orderTypeChoice === 'once';
      cta.classList.toggle('otp-foot-cta--on', has);
      cta.classList.toggle('otp-foot-cta--off', !has);
      cta.disabled = !has;
      try {
        const inactive = (window.themeOrderTypeStrings && window.themeOrderTypeStrings.cta_inactive) || '';
        const active = (window.themeOrderTypeStrings && window.themeOrderTypeStrings.cta) || '';
        ctaLabel.textContent = has ? active : inactive;
      } catch (e) {
        /* keep DOM */
      }
    }
  }

  ensureCheckoutLoader() {
    let wrap = document.querySelector('[data-delivery-checkout-loader]');
    if (wrap && wrap.isConnected) {
      this._checkoutLoaderEl = wrap;
      return wrap;
    }
    if (this._checkoutLoaderEl && this._checkoutLoaderEl.isConnected) return this._checkoutLoaderEl;
    wrap = document.createElement('div');
    wrap.className = 'delivery-checkout-loader';
    wrap.setAttribute('data-delivery-checkout-loader', '');
    wrap.hidden = true;
    wrap.setAttribute('aria-hidden', 'true');
    const backdrop = document.createElement('div');
    backdrop.className = 'delivery-checkout-loader__backdrop';
    backdrop.setAttribute('aria-hidden', 'true');
    const card = document.createElement('div');
    card.className = 'delivery-checkout-loader__card';
    card.setAttribute('role', 'status');
    card.setAttribute('aria-live', 'polite');
    const spin = document.createElement('span');
    spin.className = 'delivery-checkout-loader__spinner';
    spin.setAttribute('aria-hidden', 'true');
    const textEl = document.createElement('span');
    textEl.className = 'delivery-checkout-loader__text';
    const msg =
      (typeof window.themeCheckoutLoadingText === 'string' && window.themeCheckoutLoadingText) ||
      (window.themeOrderTypeStrings && window.themeOrderTypeStrings.checkout_loading) ||
      '…';
    textEl.textContent = msg;
    card.appendChild(spin);
    card.appendChild(textEl);
    wrap.appendChild(backdrop);
    wrap.appendChild(card);
    /** Body mount: stays visible above order-type panel (z-index 1006) and after drawer gets display:none */
    document.body.appendChild(wrap);
    this._checkoutLoaderEl = wrap;
    return wrap;
  }

  showCheckoutLoader() {
    const el = this.ensureCheckoutLoader();
    el.hidden = false;
    el.removeAttribute('hidden');
    el.setAttribute('aria-hidden', 'false');
  }

  hideCheckoutLoader() {
    const el =
      (this._checkoutLoaderEl && this._checkoutLoaderEl.isConnected && this._checkoutLoaderEl) ||
      document.querySelector('[data-delivery-checkout-loader]');
    if (!el || !el.isConnected) return;
    el.hidden = true;
    el.setAttribute('aria-hidden', 'true');
  }

  bindOrderTypePanelEventsOnce() {
    if (!this.orderTypeFlowEnabled || !this.orderTypePanel || this._orderTypeListenersBound) return;
    this._orderTypeListenersBound = true;
    const root = this.orderTypePanel;
    const getModalFocusables = () => {
      const modal = root.querySelector('[data-order-type-modal]');
      if (!modal || modal.hasAttribute('hidden')) return [];
      const sheet = modal.querySelector('[data-order-type-modal-sheet]');
      const scope = sheet || modal;
      const sel =
        'button:not([disabled]), a[href], input:not([disabled]):not([type="hidden"]), select:not([disabled]), textarea:not([disabled])';
      return [...scope.querySelectorAll(sel)].filter((el) => el.offsetParent !== null || el.getClientRects().length > 0);
    };
    root.querySelectorAll('[data-order-type-choice]').forEach((btn) => {
      btn.addEventListener('click', () => {
        const v = btn.getAttribute('data-order-type-choice');
        if (v !== 'sub' && v !== 'once') return;
        if (v === 'sub' && !this.isWeeklySubscriptionEligible()) return;
        this.orderTypeChoice = v;
        sessionStorage.setItem('promeal_order_type_choice', v);
        this.applyOrderTypeChoiceToCards();
        this.refreshOrderTypePanelPricing();
        this.dispatchOrderTypeAnalytics('select_order_type', { choice: v });
      });
    });
    const closeInfo = () => {
      const modal = root.querySelector('[data-order-type-modal]');
      if (!modal) return;
      modal.setAttribute('hidden', '');
      if (this._orderTypeModalPrevFocus && this._orderTypeModalPrevFocus.focus) {
        this._orderTypeModalPrevFocus.focus();
      }
    };
    const openInfo = () => {
      const modal = root.querySelector('[data-order-type-modal]');
      if (!modal) return;
      modal.removeAttribute('hidden');
      this._orderTypeModalPrevFocus = document.activeElement;
      const nodes = getModalFocusables();
      const focusEl = nodes[0] || modal.querySelector('[data-order-type-modal-sheet]');
      if (focusEl && focusEl.focus) focusEl.focus();
      this.dispatchOrderTypeAnalytics('subscription_info_opened', {});
      this.dispatchOrderTypeAnalytics('order_type_info_open', {});
    };
    root.querySelector('[data-order-type-info-open]')?.addEventListener('click', openInfo);
    root.querySelectorAll('[data-order-type-modal-close], [data-order-type-modal-backdrop]').forEach((el) => {
      el.addEventListener('click', closeInfo);
    });
    root.querySelector('[data-order-type-confirm]')?.addEventListener('click', async () => {
      const cta = root.querySelector('[data-order-type-confirm]');
      if (!cta || cta.getAttribute('aria-busy') === 'true') return;
      cta.setAttribute('aria-busy', 'true');
      cta.disabled = true;
      cta.classList.add('otp-foot-cta--busy');
      try {
        await this.finalizeOrderTypeAndCheckout();
      } catch (err) {
        console.error('[OrderType] checkout', err);
        this.hideCheckoutLoader();
        cta.removeAttribute('aria-busy');
        cta.disabled = false;
        cta.classList.remove('otp-foot-cta--busy');
      }
    });
    root.querySelector('[data-action="close-order-type"]')?.addEventListener('click', () => {
      this.hideDeliverySelector();
    });
    root.querySelector('[data-otp-step="1"]')?.addEventListener('click', () => {
      if (this.orderTypePhase === 'order_type') this.goBackToDateFromOrderType();
    });
    document.addEventListener('keydown', (e) => {
      const modal = root.querySelector('[data-order-type-modal]');
      if (!modal || modal.hasAttribute('hidden')) return;
      if (e.key === 'Escape') {
        e.preventDefault();
        closeInfo();
        return;
      }
      if (e.key !== 'Tab') return;
      const nodes = getModalFocusables();
      if (nodes.length < 2) return;
      const first = nodes[0];
      const last = nodes[nodes.length - 1];
      if (e.shiftKey) {
        if (document.activeElement === first || !modal.contains(document.activeElement)) {
          e.preventDefault();
          last.focus();
        }
      } else if (document.activeElement === last) {
        e.preventDefault();
        first.focus();
      }
    });
  }

  dispatchOrderTypeAnalytics(name, detail) {
    try {
      document.dispatchEvent(new CustomEvent(name, { detail: { ...detail, source: 'delivery_drawer' } }));
      if (window.dataLayer && typeof window.dataLayer.push === 'function') {
        window.dataLayer.push({ event: name, ...detail });
      }
    } catch (e) {
      /* ignore */
    }
  }

  /**
   * Same primary-subscription pick as boostify-subscriptions.js (weekly active/paused first, else newest).
   */
  pickPrimarySubscription(subs) {
    if (!subs || !subs.length) return null;
    const weeklyActive = subs.filter((s) => {
      const p = String(s.period || '').toLowerCase();
      const st = String(s.status || '').toLowerCase();
      return p === 'week' && (st === 'active' || st === 'paused');
    });
    if (weeklyActive.length) {
      weeklyActive.sort((a, b) => new Date(b.createdAt || 0) - new Date(a.createdAt || 0));
      return weeklyActive[0];
    }
    const sorted = subs.slice().sort((a, b) => new Date(b.createdAt || 0) - new Date(a.createdAt || 0));
    return sorted[0];
  }

  async fetchCustomerSubscriptions() {
    if (this._customerSubsCache !== undefined) return this._customerSubsCache;
    try {
      const res = await fetch(`${BOOSTIFY_STOREFRONT_API}/subscriptions`, {
        method: 'GET',
        credentials: 'same-origin',
        headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
      });
      if (!res.ok) {
        this._customerSubsCache = [];
        return [];
      }
      const j = await res.json();
      const list = (j.data && j.data.subscriptions) || j.data || [];
      const arr = Array.isArray(list) ? list : [];
      this._customerSubsCache = arr;
      return arr;
    } catch (e) {
      this._customerSubsCache = [];
      return [];
    }
  }

  async fetchAllPlansStorefront() {
    if (this._plansCacheAll !== undefined) return this._plansCacheAll;
    const url = `${BOOSTIFY_STOREFRONT_API}/plans`;
    const res = await fetch(url, { credentials: 'same-origin' });
    if (!res.ok) {
      this._plansCacheAll = [];
      return [];
    }
    const data = await res.json();
    const list = data && data.success ? data.data : data;
    const arr = Array.isArray(list) ? list : [];
    this._plansCacheAll = arr;
    return arr;
  }

  /** FULL_ORDER plans — same endpoint as order-repeat-button.js (`PLANS_URL`). */
  async fetchFullOrderPlans() {
    if (this._fullOrderPlansCache !== undefined) return this._fullOrderPlansCache;
    const url = `${BOOSTIFY_STOREFRONT_API}/plans?scope=FULL_ORDER`;
    const res = await fetch(url, { credentials: 'same-origin' });
    if (!res.ok) {
      this._fullOrderPlansCache = [];
      return [];
    }
    const data = await res.json();
    const list = data && data.success ? data.data : data;
    const arr = Array.isArray(list) ? list : [];
    this._fullOrderPlansCache = arr;
    return arr;
  }

  /**
   * Pick FULL_ORDER plan UUID for cart.attributes._boostify_order_repeat (order-repeat-button parity).
   * Priority: theme boostify_drawer_full_order_plan_id → primary subscription.planId if in FO list → sole FO plan → null.
   */
  async resolveFullOrderRepeatPlanId() {
    deliveryCheckoutDebugStep('resolveFullOrderRepeatPlanId:start');
    const [foPlans, subs] = await Promise.all([
      this.fetchFullOrderPlans(),
      this.fetchCustomerSubscriptions(),
    ]);
    deliveryCheckoutDebugStep('resolveFullOrderRepeatPlanId:after Boostify APIs', {
      foPlans: foPlans.length,
      subs: subs && subs.length != null ? subs.length : 0,
    });
    if (!foPlans.length) return null;

    const configured =
      (window.deliverySettings && window.deliverySettings.boostifyDrawerFullOrderPlanId) || '';
    if (configured && foPlans.some((p) => String(p.id) === String(configured))) {
      return String(configured);
    }

    const primary = this.pickPrimarySubscription(subs);
    const subPlanId = primary && (primary.planId != null ? primary.planId : primary.plan_id);
    if (subPlanId && foPlans.some((p) => String(p.id) === String(subPlanId))) {
      return String(subPlanId);
    }

    if (foPlans.length === 1) {
      return String(foPlans[0].id);
    }

    return null;
  }

  /**
   * Mirrors order-repeat-button.js `updateCartAttributes` — merges into existing cart.attributes.
   * Pass `cartSnapshot` when caller already fetched `cart.js` to skip an extra round trip.
   */
  async setOrderRepeatCartAttribute(planIdOrEmpty, cartSnapshot) {
    deliveryCheckoutDebugStep('setOrderRepeatCartAttribute:start', {
      plan: planIdOrEmpty === '' || planIdOrEmpty == null ? '(clear)' : String(planIdOrEmpty),
      hasCartSnapshot: !!cartSnapshot,
    });
    let cart = cartSnapshot;
    if (!cart) {
      const cartRes = await fetch(shopifyCartJsonPath('cart.js'), { credentials: 'same-origin' });
      cart = await cartRes.json();
      deliveryCheckoutDebugStep('setOrderRepeatCartAttribute:extra cart.js');
    }
    const attrs = { ...(cart.attributes || {}) };
    if (planIdOrEmpty === '' || planIdOrEmpty == null) {
      attrs[BOOSTIFY_CART_ATTR_ORDER_REPEAT] = '';
    } else {
      attrs[BOOSTIFY_CART_ATTR_ORDER_REPEAT] = String(planIdOrEmpty);
    }
    const res = await fetch(shopifyCartJsonPath('cart/update.js'), {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ attributes: attrs }),
    });
    deliveryCheckoutDebugStep('setOrderRepeatCartAttribute:cart/update.js', { ok: res.ok });
    if (!res.ok) {
      console.warn('[OrderType] cart/update attributes failed', await res.text());
    }
  }

  /**
   * Resolve Boostify plan for "subscription" cart line: same source order as account UI when possible
   * (customer's primary weekly subscription → planId), then product-scoped plans API, then theme fallback.
   */
  async resolveWeeklyPlanForCartLine(item) {
    const subs = await this.fetchCustomerSubscriptions();
    const primary = this.pickPrimarySubscription(subs);
    const subPlanId = primary && (primary.planId != null ? primary.planId : primary.plan_id);
    if (subPlanId) {
      const byProduct = await this.fetchPlansForProduct(item.product_id);
      let plan = byProduct.find((p) => String(p.id) === String(subPlanId));
      if (!plan) {
        const all = await this.fetchAllPlansStorefront();
        plan = all.find((p) => String(p.id) === String(subPlanId));
      }
      if (plan && (plan.sellingPlanId != null || plan.selling_plan_id != null)) {
        return plan;
      }
    }
    const plans = await this.fetchPlansForProduct(item.product_id);
    return this.pickPlanForCartLine(item, plans);
  }

  async fetchPlansForProduct(productId) {
    const key = String(productId);
    if (this._plansCacheByProductId[key]) return this._plansCacheByProductId[key];
    const url = `${BOOSTIFY_STOREFRONT_API}/plans?productId=${encodeURIComponent(key)}`;
    const res = await fetch(url, { credentials: 'same-origin' });
    if (!res.ok) {
      this._plansCacheByProductId[key] = [];
      return [];
    }
    const data = await res.json();
    const list = data && data.success ? data.data : data;
    const arr = Array.isArray(list) ? list : [];
    this._plansCacheByProductId[key] = arr;
    return arr;
  }

  pickPlanForCartLine(item, plans) {
    if (!plans || !plans.length) return null;
    const vid = item.variant_id != null ? String(item.variant_id) : '';
    const pid = item.product_id != null ? String(item.product_id) : '';
    const withSelling = plans.filter((p) => p && (p.sellingPlanId != null || p.selling_plan_id != null));
    const pool = withSelling.length ? withSelling : plans;
    for (const plan of pool) {
      const pps = plan.planProducts || [];
      if (!pps.length) continue;
      const match = pps.some((pp) => {
        const pv = pp.shopifyVariantId != null ? String(pp.shopifyVariantId) : '';
        const ppid = pp.shopifyProductId != null ? String(pp.shopifyProductId) : '';
        if (vid && pv && pv === vid) return true;
        if (pid && ppid === pid && !pv) return true;
        return false;
      });
      if (match) return plan;
    }
    return pool[0] || null;
  }

  stripBoostifyLineProperties(props) {
    const out = { ...(props || {}) };
    const keys = [
      '_boostify_plan_id',
      '_boostify_first_order_discount_code',
      '_boostify_first_order_discount_percentage',
    ];
    keys.forEach((k) => {
      if (Object.prototype.hasOwnProperty.call(out, k)) delete out[k];
    });
    return out;
  }

  async applyOrderTypeToCartLines() {
    if (PROMEAL_SKIP_ORDER_TYPE_STEP) {
      this.orderTypeChoice = 'once';
      try {
        sessionStorage.setItem('promeal_order_type_choice', 'once');
      } catch (e) {
        /* ignore */
      }
    }
    deliveryCheckoutDebugStep('applyOrderTypeToCartLines:start');
    this._pendingBoostifyOrderRepeatForCheckout = undefined;

    const fetchCartJson = () =>
      fetch(shopifyCartJsonPath('cart.js'), { credentials: 'same-origin' }).then((r) => r.json());

    /** Strip Boostify subscription fields per line; parallel safe — each request targets a distinct line `key`. */
    const clearLinesToOnetime = async (lineItems) => {
      const n = lineItems.length;
      if (!n) return;
      await Promise.all(
        lineItems.map((item, index) =>
          (async () => {
            const clean = this.stripBoostifyLineProperties(item.properties);
            const body = {
              id: item.key,
              quantity: item.quantity,
              properties: clean,
              selling_plan: null,
            };
            const r = await fetch(shopifyCartJsonPath('cart/change.js'), {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify(body),
            });
            deliveryCheckoutDebugStep(`cart/change cleanup ${index + 1}/${n}`, { ok: r.ok });
            if (!r.ok) console.warn('[OrderType] cart change line cleanup', await r.text());
            return r;
          })()
        )
      );
    };

    if (this.orderTypeChoice === 'once') {
      const cart = await fetchCartJson();
      const items = cart.items || [];
      deliveryCheckoutDebugStep('applyOrderTypeToCartLines:cart.js', { lines: items.length });
      this._pendingBoostifyOrderRepeatForCheckout = '';
      await clearLinesToOnetime(items);
      deliveryCheckoutDebugStep('applyOrderTypeToCartLines:end', { path: 'once', lines: items.length });
      return;
    }

    /** Overlap cart read + FULL_ORDER resolution — independent round-trips. */
    const [cart, fullOrderPlanId] = await Promise.all([fetchCartJson(), this.resolveFullOrderRepeatPlanId()]);
    const items = cart.items || [];
    deliveryCheckoutDebugStep('applyOrderTypeToCartLines:cart.js+resolveFullOrder', {
      lines: items.length,
      fullOrderCandidate: !!fullOrderPlanId,
    });

    if (fullOrderPlanId) {
      deliveryCheckoutDebugStep('applyOrderTypeToCartLines:full_order plan picked', { id: fullOrderPlanId });
      this._pendingBoostifyOrderRepeatForCheckout = String(fullOrderPlanId);
      await clearLinesToOnetime(items);
      deliveryCheckoutDebugStep('applyOrderTypeToCartLines:end', { path: 'full_order', lines: items.length });
      return;
    }

    await this.setOrderRepeatCartAttribute('', cart);

    const fallbackPlanId = (window.deliverySettings && window.deliverySettings.boostifyFallbackPlanId) || '';
    const fallbackSelling = (window.deliverySettings && window.deliverySettings.boostifyFallbackSellingPlanId) || '';
    /** Resolve all Boostify plans in parallel (reads only); writes stay sequential for cart integrity. */
    const plansResolved =
      items.length > 0 ? await Promise.all(items.map((item) => this.resolveWeeklyPlanForCartLine(item))) : [];
    deliveryCheckoutDebugStep('applyOrderTypeToCartLines:Promise.all weekly plans', { lines: items.length });

    const subscriptionWrites = [];
    for (let i = 0; i < items.length; i++) {
      const item = items[i];
      let plan = plansResolved[i];
      let sellingId = plan ? plan.sellingPlanId ?? plan.selling_plan_id : null;
      let planId = plan ? plan.id : null;
      if ((!sellingId || !planId) && fallbackSelling && fallbackPlanId) {
        sellingId = Number(fallbackSelling);
        planId = String(fallbackPlanId);
        plan = { discountFromFirstOrder: false };
      }
      if (!sellingId || !planId) {
        console.warn('[OrderType] skip line — no PRODUCTS plan', item);
        continue;
      }
      const planMeta = plan || {};
      const props = { ...(item.properties || {}) };
      props._boostify_plan_id = String(planId);
      if (planMeta.discountFromFirstOrder && planMeta.firstOrderDiscountCode) {
        props._boostify_first_order_discount_code = planMeta.firstOrderDiscountCode;
        props._boostify_first_order_discount_percentage = String(planMeta.discountPercentage || 0);
      }
      const body = {
        id: item.key,
        quantity: item.quantity,
        selling_plan: Number(sellingId),
        properties: props,
      };
      const idx = i;
      const total = items.length;
      subscriptionWrites.push(
        fetch(shopifyCartJsonPath('cart/change.js'), {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(body),
        }).then(async (r) => {
          deliveryCheckoutDebugStep(`cart/change subscription line ${idx + 1}/${total}`, { ok: r.ok });
          if (!r.ok) console.warn('[OrderType] cart change sub', await r.text());
          return r;
        })
      );
    }
    await Promise.all(subscriptionWrites);
    deliveryCheckoutDebugStep('applyOrderTypeToCartLines:end', { lines: items.length });
  }

  async finalizeOrderTypeAndCheckout() {
    if (PROMEAL_SKIP_ORDER_TYPE_STEP) {
      this.orderTypeChoice = 'once';
      try {
        sessionStorage.setItem('promeal_order_type_choice', 'once');
      } catch (e) {
        /* ignore */
      }
    }
    try {
      sessionStorage.removeItem('promeal_boostify_card_update');
    } catch (e) {
      /* ignore */
    }
    if (!this.orderTypeChoice) return;
    if (this.orderTypeChoice === 'sub' && !this.isWeeklySubscriptionEligible()) {
      this.orderTypeChoice = 'once';
      sessionStorage.setItem('promeal_order_type_choice', 'once');
      this.applyOrderTypeMinMealsState();
      this.applyOrderTypeChoiceToCards();
      return;
    }
    this.showCheckoutLoader();
    deliveryCheckoutDebugReset();
    deliveryCheckoutDebugStep('finalizeOrderTypeAndCheckout:start');
    try {
      await this.applyOrderTypeToCartLines();
      deliveryCheckoutDebugStep('finalize:after applyOrderTypeToCartLines');
      this.selectedFrequency = this.orderTypeChoice === 'sub' ? 'weekly' : 'onetime';
      sessionStorage.setItem('promeal_order_type_choice', this.orderTypeChoice);
      this.syncDeliveryFlowSteppers(3);
      deliveryCheckoutDebugStep('finalize:before confirmSelection');
      await this.confirmSelection();
      deliveryCheckoutDebugStep('finalize:after confirmSelection (only if no navigation)');
    } catch (e) {
      this.hideCheckoutLoader();
      throw e;
    }
  }

  /**
   * Prefetch Boostify + per-product plans when user lands on order-type step so checkout click avoids cold caches.
   */
  warmCheckoutCachesForOrderType() {
    if (!this.orderTypeFlowEnabled) return;
    Promise.all([
      this.fetchFullOrderPlans(),
      this.fetchCustomerSubscriptions(),
      fetch(shopifyCartJsonPath('cart.js'), { credentials: 'same-origin' })
        .then((r) => r.json())
        .then((c) => {
          const ids = [...new Set((c.items || []).map((i) => i.product_id).filter(Boolean))];
          return Promise.all(ids.map((pid) => this.fetchPlansForProduct(pid)));
        }),
    ]).catch(() => {});
  }
  
  async confirmSelection() {
    if (isDeliveryCheckoutDebug() && !this.orderTypeFlowEnabled) {
      deliveryCheckoutDebugReset();
    }

    // Ensure frequency is set to 'onetime' if null
    if (!this.selectedFrequency) {
      console.log('Frequency was null, defaulting to onetime');
      this.selectedFrequency = 'onetime';
    }

    console.log(
      'Confirming selection',
      'frequency=' + String(this.selectedFrequency),
      'date=' + (this.selectedDate ? this.selectedDate.toISOString() : '')
    );
    
    // Double-check that we have both date and frequency selected
    const selectedDateOption = this.selector.querySelector('.date-option.selected');
    const selectedFrequencyOption = this.selector.querySelector('.frequency-option.selected');
    
    // If we don't have a date selected, try to get it from the UI
    if (!this.selectedDate && selectedDateOption) {
      const dayElement = selectedDateOption.querySelector('.date-day');
      const dateElement = selectedDateOption.querySelector('.date-number');
      
      if (dayElement && dateElement) {
        const dayName = dayElement.textContent;
        const dateText = dateElement.textContent;
        this.selectedDate = this.parseDateFromText(dayName, dateText);
      }
    }
    
    // If we don't have a frequency selected, try to get it from the UI
    if (!this.selectedFrequency && selectedFrequencyOption) {
      this.selectedFrequency = selectedFrequencyOption.dataset.frequency;
    }
    
    // Force onetime if still null (fallback)
    if (!this.selectedFrequency) {
      this.selectedFrequency = 'onetime';
    }
    
    // Final validation check
    if (!this.selectedDate) {
      this.hideCheckoutLoader();
      this.currentStep = 1;
      this.updateStepUI();
      this.showValidationError('date');
      return;
    }

    if (!this.selectedFrequency) {
      this.hideCheckoutLoader();
      this.showValidationError('frequency');
      return;
    }

    this.showCheckoutLoader();

    // Store selections in localStorage
    if (this.selectedDate) {
      localStorage.setItem('selectedDeliveryDate', this.selectedDate.toISOString());
      
      // Also store a formatted version for display
      const formattedDate = `${this.getDayNameHebrew(this.selectedDate)}, ${this.formatDate(this.selectedDate)}`;
      localStorage.setItem('formattedDeliveryDate', formattedDate);
    }
    
    if (this.selectedFrequency) {
      localStorage.setItem('selectedDeliveryFrequency', this.selectedFrequency);
      
      // Also store a translated version for display
      const translatedFrequency = this.getTranslatedFrequency(this.selectedFrequency);
      localStorage.setItem('translatedDeliveryFrequency', translatedFrequency);
    }
    
    // Cart attributes must land before navigation (removed fixed delays; await replaces fire-and-forget)
    deliveryCheckoutDebugStep('confirmSelection:before updateCartWithDeliveryInfoAsync');
    try {
      await this.updateCartWithDeliveryInfoAsync();
      deliveryCheckoutDebugStep('confirmSelection:after updateCartWithDeliveryInfoAsync');
    } catch (error) {
      console.error('Error updating cart with delivery info', error);
      deliveryCheckoutDebug('confirmSelection:updateCartWithDeliveryInfoAsync FAILED', error);
    }

    // Panel closes in proceedToCheckout (closePanel) — avoid double closePanel + 300ms work before submit

    // Check if discount should be applied
    // Get the last order input element to check if cart matches last order
    const lastOrderInput = document.getElementById('lastOrderVariants');
    let shouldApplyDiscount = false;
    
    if (lastOrderInput) {
      // Get the cart comparison status from the UI
      const lastOrderLink = document.querySelector('.last-order-link');
      const isMatching = lastOrderLink && lastOrderLink.classList.contains('is-matching');
      
      // Get the total comparison status
      const totalComparisonElement = lastOrderLink && lastOrderLink.querySelector('.total-comparison');
      const isTotalSameOrGreater = totalComparisonElement && 
                                  totalComparisonElement.textContent.includes('תואם או גבוה יותר');
      
      // Determine if discount should be applied based on configuration
      const discountConfig = {
        requireItemMatch: true,
        requireTotalMatch: true,
        matchType: 'both'  // can be 'both', 'either', 'items_only', 'total_only'
      };
      
      switch(discountConfig.matchType) {
        case 'both':
          shouldApplyDiscount = isMatching && isTotalSameOrGreater;
          break;
        case 'either':
          shouldApplyDiscount = isMatching || isTotalSameOrGreater;
          break;
        case 'items_only':
          shouldApplyDiscount = isMatching;
          break;
        case 'total_only':
          shouldApplyDiscount = isTotalSameOrGreater;
          break;
      }
      
      console.log('Discount application check:', {
        isMatching,
        isTotalSameOrGreater,
        shouldApplyDiscount,
        matchType: discountConfig.matchType
      });
    }
    
    let checkoutDiscount = null;
    if (this.selectedFrequency === 'weekly' && shouldApplyDiscount) {
      checkoutDiscount = 'SUB_WEEKLY_10';
    } else if (this.selectedFrequency === 'biweekly' && shouldApplyDiscount) {
      checkoutDiscount = 'SUB_WEEKLY_5';
    } else if (this.selectedFrequency !== 'onetime') {
      const lastOrderInput2 = document.getElementById('lastOrderVariants');
      const customerSubscriptionElement2 = document.querySelector('[data-customer-subscription]');
      if (
        lastOrderInput2 &&
        customerSubscriptionElement2 &&
        customerSubscriptionElement2.getAttribute('data-customer-subscription')
      ) {
        checkoutDiscount = 'LOYALFAN';
      }
    }

    deliveryCheckoutDebugStep('confirmSelection:before proceedToCheckout', {
      discount: checkoutDiscount || null,
    });
    this.proceedToCheckout(checkoutDiscount ? { discount: checkoutDiscount } : {});
  }
  
  proceedToCheckout(opts) {
    deliveryCheckoutDebugStep('proceedToCheckout:enter');
    const options = opts || {};
    // Find the cart form
    const form = document.getElementById('cart');
    if (form) {
      // Add hidden inputs for delivery options
      let dateInput = form.querySelector('input[name="attributes[delivery_date]"]');
      if (!dateInput) {
        dateInput = document.createElement('input');
        dateInput.type = 'hidden';
        dateInput.name = 'attributes[delivery_date]';
        form.appendChild(dateInput);
      }
      dateInput.value = this.formatDate(this.selectedDate);
      
      let frequencyInput = form.querySelector('input[name="attributes[delivery_frequency]"]');
      if (!frequencyInput) {
        frequencyInput = document.createElement('input');
        frequencyInput.type = 'hidden';
        frequencyInput.name = 'attributes[delivery_frequency]';
        form.appendChild(frequencyInput);
      }
      frequencyInput.value = this.selectedFrequency;
      
      // Close the panel before submitting (keep overlay visible until checkout navigates)
      this.closePanel({ keepCheckoutLoader: true });
      deliveryCheckoutDebugStep('proceedToCheckout:after closePanel');

      // Submit the form to go to checkout (optional discount via query string)
      const q = options.discount ? `?discount=${encodeURIComponent(options.discount)}` : '';
      form.action = '/checkout' + q;

      deliveryCheckoutDebugStep('proceedToCheckout:form.submit (theme JS ends here; checkout HTML loads next)');
      form.submit();
    } else {
      this.closePanel({ keepCheckoutLoader: true });
      const q = options.discount ? `?discount=${encodeURIComponent(options.discount)}` : '';
      window.location.href = '/checkout' + q;
    }
  }
  
  showPanel() {
    // Reset to first step
    this.currentStep = 1;
    if (this.orderTypeFlowEnabled) {
      this.orderTypePhase = 'date';
      if (this.orderTypePanel) {
        this.orderTypePanel.classList.remove('show');
        this.orderTypePanel.setAttribute('hidden', '');
      }
    }
    this.syncDeliveryFlowSteppers(1);
    
    // Show the selector container
    this.selector.style.display = 'block';
    
    // Drawer: show date panel immediately so desktop single-shell (.drawer-delivery-sheet) is never empty
    if (this.isDrawer) {
      this.panel.classList.add('show');
    } else {
      setTimeout(() => {
        this.panel.classList.add('show');
      }, 10);
    }
    
    // Show the overlay
    if (this.overlay) {
      this.overlay.style.display = 'block';
    }
    
    document.body.style.overflow = 'hidden';
    
    // Update UI
    this.updateUI();
  }
  
  closePanel(opts = {}) {
    if (!opts.keepCheckoutLoader) {
      this.hideCheckoutLoader();
    }
    // Instead of calling hideDeliverySelector, implement the closing logic directly
    const panel = this.selector.querySelector('.delivery-date-panel');
    if (this.orderTypeFlowEnabled) {
      this.orderTypePhase = 'date';
      if (this.orderTypePanel) {
        this.orderTypePanel.classList.remove('show');
        this.orderTypePanel.setAttribute('hidden', '');
      }
    }
    if (panel) {
      // First hide the panel for animation
      panel.classList.remove('show');
      
      // After the transition completes, hide the container and overlay
      setTimeout(() => {
        this.selector.style.display = 'none';
        const overlay = this.selector.querySelector('.delivery-panel-overlay');
        if (overlay) {
          overlay.style.display = 'none';
        }
        document.body.style.overflow = '';
        
        // If we have a selected date, make sure it's still selected when we reopen
        if (this.selectedDate) {
          localStorage.setItem('tempSelectedDate', this.selectedDate.toISOString());
        }
      }, 300); // Match this to the CSS transition duration
    }
  }
  
  updateUI() {
    // Update step visibility
    this.updateStepUI();
    
    // Update the confirm button
    const confirmButton = this.selector.querySelector('[data-action="confirm"]');
    if (confirmButton) {
      // On first step, always enable the button
      if (this.currentStep === 1) {
        confirmButton.disabled = false;
        confirmButton.classList.remove('disabled');
        confirmButton.style.opacity = '1';
      } else if (this.currentStep === 2) {
        // On second step, only enable if frequency is selected
        const isDisabled = !this.selectedFrequency;
        confirmButton.disabled = isDisabled;
        
        if (isDisabled) {
          confirmButton.classList.add('disabled');
          confirmButton.style.opacity = '0.5';
        } else {
          confirmButton.classList.remove('disabled');
          confirmButton.style.opacity = '1';
        }
      }
    }
    
    // Update the confirm button text
    this.updateConfirmButtonText();
    
    // Update the button layout
    this.updateButtonLayout();
  }
  
  displaySavedSelectionsInCart() {
    const selectedDate = localStorage.getItem('selectedDeliveryDate');
    const selectedFrequency = localStorage.getItem('selectedDeliveryFrequency');
    
    // Only proceed if we have selections
    if (!selectedDate && !selectedFrequency) return;
    
    // Clear any existing delivery info displays
    const existingInfoElements = document.querySelectorAll('.cart-delivery-info');
    existingInfoElements.forEach(el => {
      // Find the parent wrapper and remove it entirely
      const wrapper = el.closest('.delivery-info-wrapper');
      if (wrapper) {
        wrapper.remove();
      } else {
        el.remove();
      }
    });
    
    // Create the delivery info display
    const deliveryInfoElement = document.createElement('div');
    deliveryInfoElement.className = 'delivery-info-wrapper';
    deliveryInfoElement.innerHTML = `
      <div class="cart-delivery-info">
        <h4>פרטי משלוח</h4>
        ${selectedDate ? `<p>תאריך משלוח: ${selectedDate}</p>` : ''}
        ${selectedFrequency ? `<p>תדירות: ${this.getFrequencyLabel(selectedFrequency)}</p>` : ''}
        <button class="edit-delivery-info">ערוך</button>
      </div>
    `;
    
    // Find all delivery info placeholders
    const cartPlaceholders = document.querySelectorAll('.cart-delivery-info-placeholder');
    
    // Clone and append to each placeholder
    cartPlaceholders.forEach(placeholder => {
      // Clear any existing content in the placeholder first
      placeholder.innerHTML = '';
      const clone = deliveryInfoElement.cloneNode(true);
      placeholder.appendChild(clone);
    });
    
    // Add event listeners to all edit buttons
    document.querySelectorAll('.edit-delivery-info').forEach(button => {
      button.addEventListener('click', this.handleEditButtonClick.bind(this));
    });
  }
  
  // Helper method to get human-readable frequency label
  getFrequencyLabel(frequency) {
    const labels = {
      'weekly': 'כל שבוע',
      'biweekly': 'כל שבועיים',
      'monthly': 'כל 4 שבועות',
      'onetime': 'רכישה חד פעמית'
    };
    return labels[frequency] || frequency;
  }
  
  // Add a method to handle edit button clicks
  handleEditButtonClick(e) {
    e.preventDefault();
    
    // Find the appropriate delivery selector
    let deliverySelector;
    const isDrawer = e.target.closest('#AjaxCartForm') !== null && !e.target.closest('#AjaxCartForm').closest('.cart-section');
    
    if (isDrawer) {
      // For drawer cart - use the slide-up version
      deliverySelector = document.querySelector('#DrawerDeliveryFrequencySelector');
    } else {
      // For cart page - use the modal version
      deliverySelector = document.querySelector('#DeliveryFrequencySelector.delivery-frequency-modal');
    }
    
    if (deliverySelector) {
      // Show the delivery selector
      deliverySelector.style.display = 'block';
      
      // Get the panel element and overlay
      const panel = deliverySelector.querySelector('.delivery-date-panel');
      const overlay = deliverySelector.querySelector('.delivery-panel-overlay');
      
      // Show the overlay
      if (overlay) {
        overlay.style.display = 'block';
      }
      
      const drawerRoot = deliverySelector.id === 'DrawerDeliveryFrequencySelector';
      if (drawerRoot && panel) {
        panel.classList.add('show');
      } else {
        setTimeout(() => {
          if (panel) panel.classList.add('show');
        }, 10);
      }
      
      document.body.style.overflow = 'hidden';
      
      const instance = window.deliveryFrequencyInstances.find(
        inst => inst.selector === deliverySelector
      );
      
      if (instance) {
        instance.currentStep = 1;
        if (instance.orderTypeFlowEnabled) {
          instance.orderTypePhase = 'date';
          if (instance.orderTypePanel) {
            instance.orderTypePanel.classList.remove('show');
            instance.orderTypePanel.setAttribute('hidden', '');
          }
        }
        instance.syncDeliveryFlowSteppers(1);
        instance.updateUI();
      }
    }
  }
  
  // Update the showDeliverySelector method to fully reset the UI
  showDeliverySelector(isDrawer = false) {
    console.log("Showing delivery selector");
    
    // Always reset to first step and clear selections
    this.currentStep = 1;
    this.selectedDate = null;
    this.selectedFrequency = null;
    if (this.orderTypeFlowEnabled) {
      this.orderTypePhase = 'date';
      if (this.orderTypePanel) {
        this.orderTypePanel.classList.remove('show');
        this.orderTypePanel.setAttribute('hidden', '');
      }
      this.setDefaultOrderTypeChoice();
    }
    this.syncDeliveryFlowSteppers(1);
    
    // Clear localStorage for temporary selections
    localStorage.removeItem('tempSelectedDate');
    
    // Show the delivery selector panel
    this.selector.style.display = 'block';
    
    // Update the cart total amount
    this.setCartTotal();
    
    // Regenerate date options to reflect current cart state
    this.generateDateOptions();
    if (this.isSundayAckFlow()) {
      this.updateClosestSundayAck();
    }

    // Compare cart with last order
    this.compareCartWithLastOrder();
    
    // Show the panel
    this.panel.classList.add('show');
    
    // Show the overlay
    if (this.overlay) {
      this.overlay.style.display = 'block';
    }
    
    document.body.style.overflow = 'hidden';
    
    // Reset UI selections - make sure no date or frequency appears selected
    this.resetUISelections();
    
    // Check if customer has subscription tag and pre-select frequency
    this.checkCustomerSubscription();
    
    // Clear any validation messages
    this.clearValidationMessages();
    
    // Update the UI to reflect the current selections
    this.updateUI();
    
    // Make sure the confirm button text is updated
    this.updateConfirmButtonText();
  }

  // Add a method to check for customer subscription tags
  checkCustomerSubscription() {
    // Look for customer subscription info in the page
    const subscriptionElement = document.querySelector('[data-customer-subscription]');
    
    if (subscriptionElement) {
      const subscription = subscriptionElement.dataset.customerSubscription;
      const translatedSubscription = subscriptionElement.dataset.translatedSubscription;
      console.log("Found customer subscription:", subscription, "Translated:", translatedSubscription);
      
      if (subscription) {
        // Map subscription to frequency option
        let frequency = null;
        
        switch (subscription) {
          case 'weekly':
            frequency = 'weekly';
            break;
          case 'biweekly':
            frequency = 'biweekly';
            break;
          case 'monthly':
            frequency = 'monthly';
            break;
        }
        
        if (frequency) {
          console.log("Pre-selecting frequency:", frequency);
          this.selectedFrequency = frequency;
          
          // Find the matching frequency option and add the existing subscription tag
          const frequencyOption = this.selector.querySelector(`.frequency-option[data-frequency="${frequency}"]`);
          if (frequencyOption) {
            // Mark the subscription option as selected
            frequencyOption.classList.add('selected');
            
            // Create or get the subscription info row
            let subscriptionInfoRow = frequencyOption.querySelector('.subscription-info-row');
            if (!subscriptionInfoRow) {
              subscriptionInfoRow = document.createElement('div');
              subscriptionInfoRow.className = 'subscription-info-row';
              subscriptionInfoRow.style.display = 'flex';
              subscriptionInfoRow.style.flexDirection = 'column';
              subscriptionInfoRow.style.alignItems = 'flex-start';
              frequencyOption.appendChild(subscriptionInfoRow);
            }
            
            // Add the subscription status container
            const subscriptionStatusContainer = document.createElement('div');
            subscriptionStatusContainer.className = 'subscription-status-container';
            subscriptionStatusContainer.style.display = 'flex';
            subscriptionStatusContainer.style.flexDirection = 'column';
            subscriptionStatusContainer.style.alignItems = 'flex-start';
            subscriptionStatusContainer.style.marginRight = 'auto';
            
            // Add the existing subscription tag
            if (!subscriptionInfoRow.querySelector('.existing-subscription-tag')) {
              // Create a link element instead of a span
              const existingTag = document.createElement('a');
              existingTag.className = 'existing-subscription-tag';
              existingTag.textContent = 'עדכון מנוי קיים';
              existingTag.href = '/account';
              existingTag.style.marginBottom = '5px';
              existingTag.style.textDecoration = 'none';
              existingTag.style.display = 'inline-block';
              subscriptionStatusContainer.appendChild(existingTag);

              // Remove the separate account link since it's now combined with the tag
              
              // Add the container to the subscription info row
              subscriptionInfoRow.appendChild(subscriptionStatusContainer);
            }
            
            // Add a lock icon
            if (!subscriptionInfoRow.querySelector('.lock-icon')) {
              const lockIcon = document.createElement('span');
              lockIcon.className = 'lock-icon';
              lockIcon.innerHTML = '🔒';
              subscriptionInfoRow.appendChild(lockIcon);
            }
            
            // Add the subscription note
            if (!subscriptionInfoRow.querySelector('.subscription-note')) {
              const note = document.createElement('span');
              note.className = 'subscription-note';
              note.textContent = 'מוגדר לפי המנוי שלך';
              subscriptionInfoRow.appendChild(note);
            }
          }
          
          // Disable other subscription options except one-time and the customer's subscription
          const frequencyOptions = this.selector.querySelectorAll('.frequency-option');
          frequencyOptions.forEach(option => {
            const optionFrequency = option.dataset.frequency;
            if (optionFrequency !== frequency && optionFrequency !== 'onetime') {
              option.classList.add('disabled');
              option.style.opacity = '0.5';
              option.style.cursor = 'not-allowed';
              
              // Remove click event listener
              const newOption = option.cloneNode(true);
              option.parentNode.replaceChild(newOption, option);
            }
          });
          
          // Enable the confirm button since we have a pre-selected frequency
          const confirmButton = this.selector.querySelector('[data-action="confirm"]');
          if (confirmButton) {
            confirmButton.disabled = false;
          }
        }
      }
    }
  }

  // Method to disable frequency selection
  disableFrequencySelection() {
    const frequencyOptions = this.selector.querySelectorAll('.frequency-option');
    
    frequencyOptions.forEach(option => {
      const frequency = option.dataset.frequency;
      
      // Allow clicking on one-time purchase or the selected frequency (existing subscription)
      if (frequency !== this.selectedFrequency && frequency !== 'onetime') {
        option.classList.add('disabled');
        option.style.opacity = '0.5';
        option.style.cursor = 'not-allowed';
        
        // Remove click event listener
        const newOption = option.cloneNode(true);
        option.parentNode.replaceChild(newOption, option);
      } else if (frequency === this.selectedFrequency) {
        option.classList.add('selected');
        option.classList.add('locked');
        
        // Create or get the subscription info row
        let subscriptionInfoRow = option.querySelector('.subscription-info-row');
        if (!subscriptionInfoRow) {
          subscriptionInfoRow = document.createElement('div');
          subscriptionInfoRow.className = 'subscription-info-row';
          subscriptionInfoRow.style.display = 'flex';
          subscriptionInfoRow.style.flexDirection = 'column';
          subscriptionInfoRow.style.alignItems = 'flex-start';
          option.appendChild(subscriptionInfoRow);
        }
        
        // Add the subscription status container
        const subscriptionStatusContainer = document.createElement('div');
        subscriptionStatusContainer.className = 'subscription-status-container';
        subscriptionStatusContainer.style.display = 'flex';
        subscriptionStatusContainer.style.flexDirection = 'column';
        subscriptionStatusContainer.style.alignItems = 'flex-start';
        subscriptionStatusContainer.style.marginRight = 'auto';
        
        // Add the existing subscription tag if not already present
        if (!subscriptionInfoRow.querySelector('.existing-subscription-tag')) {
          const existingTag = document.createElement('a');
          existingTag.className = 'existing-subscription-tag';
          existingTag.textContent = 'עדכון מנוי קיים';
          existingTag.href = '/account';
          existingTag.style.marginBottom = '5px';
          existingTag.style.textDecoration = 'none';
          existingTag.style.display = 'inline-block';
          subscriptionStatusContainer.appendChild(existingTag);
          subscriptionInfoRow.appendChild(subscriptionStatusContainer);
        }
      }
    });
    
    // Skip to the next step if we're on the frequency step
    if (this.currentStep === 2) {
      this.goToNextStep();
    }
  }

  // Add this method to check for out-of-stock items in the cart
  checkCartForOutOfStockItems() {
    const outOfStockBadges = document.querySelectorAll('.cart-item__badge--delivery');
    if (outOfStockBadges.length > 0) {
      return true;
    }

    const cartItems = document.querySelectorAll('.cart-item');
    for (const item of cartItems) {
      if (item.classList.contains('out-of-stock')) {
        return true;
      }
      if (item.dataset.outOfStock === 'true') {
        return true;
      }
    }

    return false;
  }

  // Add method to check if any cart item has the one-time delivery tag
  hasOneTimeDeliveryTag() {
    const oneTimeDeliveryTag = window.deliverySettings?.oneTimeDatesTags || '';

    if (!oneTimeDeliveryTag || oneTimeDeliveryTag === 'none') {
      return false;
    }

    const cartItems = document.querySelectorAll('.cart-item');
    const oneTimeEls = document.querySelectorAll('[data-one-time-delivery="true"]');
    const hasGlobalOneTime = Array.from(oneTimeEls).some(
      (el) => el.dataset.oneTimeDelivery === 'true'
    );
    if (hasGlobalOneTime) {
      return true;
    }

    for (const item of cartItems) {
      if (
        item.classList.contains(oneTimeDeliveryTag) ||
        (item.dataset.tags && item.dataset.tags.includes(oneTimeDeliveryTag)) ||
        item.hasAttribute(`data-tag-${oneTimeDeliveryTag}`)
      ) {
        return true;
      }
    }

    return false;
  }

  // Add this method to get the next available delivery date from our liquid snippet
  getNextAvailableDeliveryDate() {
    const deliveryBadge = document.querySelector('.cart-item__badge--delivery');

    if (deliveryBadge) {
      const badgeText = deliveryBadge.textContent.trim();
      const dateMatch = badgeText.match(/(\d{2}\/\d{2})$/);

      if (dateMatch && dateMatch[1]) {
        const dateParts = dateMatch[1].split('/');
        const day = parseInt(dateParts[0], 10);
        const month = parseInt(dateParts[1], 10) - 1;

        const currentYear = new Date().getFullYear();
        const nextDeliveryDate = new Date(currentYear, month, day);

        if (nextDeliveryDate < new Date()) {
          nextDeliveryDate.setFullYear(currentYear + 1);
        }

        return nextDeliveryDate;
      }
    }

    return null;
  }

  // Add logging to getDayName
  getDayName(date) {
    const days = ['sunday', 'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday'];
    const dayName = days[date.getDay()];
   // console.log(`Getting day name for ${date}: ${dayName}`);
    return dayName;
  }

  // Add this helper method to get Hebrew day names
  getDayNameHebrew(date) {
    const dayNames = {
      0: "יום ראשון",
      1: "יום שני",
      2: "יום שלישי",
      3: "יום רביעי",
      4: "יום חמישי",
      5: "יום שישי",
      6: "יום שבת"
    };
    return dayNames[date.getDay()];
  }

  // Enhance the handleCartUpdate method to always reset the date when cart changes
  handleCartUpdate() {
    const currentOutOfStock = this.checkCartForOutOfStockItems();
    const currentItemCount = document.querySelectorAll('.cart-item').length;

    const hasStateChanged =
      currentOutOfStock !== this.cartState.hasOutOfStock ||
      currentItemCount !== this.cartState.itemCount;

    if (hasStateChanged) {
      this.cartState = {
        hasOutOfStock: currentOutOfStock,
        itemCount: currentItemCount,
      };

      this.scheduleGenerateDateOptions();
      this.setCartTotal();
      this.compareCartWithLastOrder();
      this.updateUI();
      this.displaySavedSelectionsInCart();
    } else if (this.orderTypeFlowEnabled) {
      this.setCartTotal();
    }
    if (this.orderTypeFlowEnabled && this.orderTypePhase === 'order_type') {
      fetch(shopifyCartJsonPath('cart.js'), { credentials: 'same-origin' })
        .then((r) => r.json())
        .then((cart) => this.refreshOrderTypeMealEligibility(cart))
        .catch(() => {});
    }
  }

  // Add a method to update the confirm button text based on current step
  updateConfirmButtonText() {
    // Support both old and new button classes
    const confirmButton = this.selector.querySelector('[data-action="confirm"]');
    const checkoutBtnNew = this.selector.querySelector('.checkout-btn-new');
    
    if (confirmButton && !checkoutBtnNew) {
      confirmButton.innerHTML = 'לתשלום <span class="arrow">←</span>';
    }
    // New button keeps its original text from HTML
  }

  // Add a method to show validation errors
  showValidationError(type) {
    if (type === 'date') {
      // Flash the date options or show a message (support both old and new classes)
      const dateOptions = this.selector.querySelector('.date-grid-new, .date-options');
      if (dateOptions) {
        dateOptions.classList.add('validation-error');
        
        // Add a validation message
        let errorMsg = this.selector.querySelector('.validation-message');
        if (!errorMsg) {
          errorMsg = document.createElement('div');
          errorMsg.className = 'validation-message';
          errorMsg.style.cssText = 'text-align: center; color: #dc2626; font-size: 14px; margin-top: 12px; font-weight: 500;';
          errorMsg.textContent = 'אנא בחר תאריך משלוח';
          dateOptions.parentNode.insertBefore(errorMsg, dateOptions.nextSibling);
        } else {
          // Make sure the message is visible
          errorMsg.style.display = 'block';
          errorMsg.textContent = 'אנא בחר תאריך משלוח';
        }
        
        // Scroll to the date options
        dateOptions.scrollIntoView({ behavior: 'smooth', block: 'center' });
        
        // Remove the error styling after animation
        setTimeout(() => {
          dateOptions.classList.remove('validation-error');
        }, 1000);
      }
    } else if (type === 'frequency') {
      // Flash the frequency options or show a message
      const frequencyOptions = this.selector.querySelector('.frequency-options');
      if (frequencyOptions) {
        frequencyOptions.classList.add('validation-error');
        
        // Add a validation message
        let errorMsg = this.selector.querySelector('.validation-message');
        if (!errorMsg) {
          errorMsg = document.createElement('div');
          errorMsg.className = 'validation-message';
          errorMsg.textContent = 'אנא בחר תדירות משלוח';
          frequencyOptions.parentNode.insertBefore(errorMsg, frequencyOptions.nextSibling);
        } else {
          // Make sure the message is visible
          errorMsg.style.display = 'block';
          errorMsg.textContent = 'אנא בחר תדירות משלוח';
        }
        
        // Scroll to the frequency options
        frequencyOptions.scrollIntoView({ behavior: 'smooth', block: 'center' });
        
        // Remove the error styling after animation
        setTimeout(() => {
          frequencyOptions.classList.remove('validation-error');
        }, 1000);
      }
    }
  }

  // Update the hideDeliverySelector method to hide the panel
  hideDeliverySelector() {
    this.closePanel();
  }

  // Helper method to get translated frequency
  getTranslatedFrequency(frequency) {
    const translations = {
      'weekly': 'כל שבוע',
      'biweekly': 'כל שבועיים',
      'monthly': 'פעם בחודש',
      'onetime': 'חד פעמי'
    };
    
    return translations[frequency] || frequency;
  }

  // Update the clearValidationMessages method to be even more thorough
  clearValidationMessages() {
    const errorElements = this.selector.querySelectorAll('.validation-error');
    errorElements.forEach((element) => {
      element.classList.remove('validation-error');
    });

    const messageElements = this.selector.querySelectorAll('.validation-message');
    messageElements.forEach((element) => {
      if (element.parentNode) {
        element.parentNode.removeChild(element);
      }
    });

    // Remove any inline validation messages that might have been added
    const dateOptions = this.selector.querySelector('.date-options');
    const frequencyOptions = this.selector.querySelector('.frequency-options');
    
    if (dateOptions) {
      dateOptions.classList.remove('validation-error');
      const dateValidationMsg = dateOptions.nextElementSibling;
      if (dateValidationMsg && (dateValidationMsg.classList.contains('validation-message') || 
                               dateValidationMsg.textContent === 'אנא בחר תאריך משלוח')) {
        dateValidationMsg.remove();
      }
    }
    
    if (frequencyOptions) {
      frequencyOptions.classList.remove('validation-error');
      const freqValidationMsg = frequencyOptions.nextElementSibling;
      if (freqValidationMsg && (freqValidationMsg.classList.contains('validation-message') || 
                               freqValidationMsg.textContent === 'אנא בחר תדירות משלוח')) {
        freqValidationMsg.remove();
      }
    }
  }

  // Add a method to reset UI selections
  resetUISelections() {
    // Clear date selections
    const dateOptions = this.selector.querySelectorAll('.date-option');
    dateOptions.forEach(option => {
      option.classList.remove('selected');
    });
    
    // Clear frequency selections
    const frequencyOptions = this.selector.querySelectorAll('.frequency-option');
    frequencyOptions.forEach(option => {
      option.classList.remove('selected');
    });
    
    // Disable next step button
    const nextStepBtn = this.selector.querySelector('[data-action="next-step"]');
    if (nextStepBtn) {
      nextStepBtn.disabled = true;
    }
    
    // Reset shipping labels to default state
    if (this.freeShippingLabel && this.paidShippingLabel) {
      this.freeShippingLabel.classList.add('hidden');
      this.paidShippingLabel.classList.remove('hidden');
    }
  }

  // Update the updateButtonLayout method to check for selected dates in the UI
  updateButtonLayout() {
    const confirmSection = this.selector.querySelector('.confirm-section');
    const confirmButton = this.selector.querySelector('[data-action="confirm"]');
    
    if (!confirmSection || !confirmButton) return;
    
    // Create a button container if it doesn't exist
    let buttonContainer = confirmSection.querySelector('.button-container');
    if (!buttonContainer) {
      buttonContainer = document.createElement('div');
      buttonContainer.className = 'button-container';
      
      // Move the confirm button into the container
      const originalButton = confirmButton.cloneNode(true);
      confirmButton.parentNode.replaceChild(buttonContainer, confirmButton);
      buttonContainer.appendChild(originalButton);
      
      // Add event listener to the new button
      originalButton.addEventListener('click', async (event) => {
        event.preventDefault();
        
        // Try to set the selected date from the UI if it's not already set
        if (!this.selectedDate) {
          this.setSelectedDateFromUI();
        }
        
        console.log('Confirm button clicked', {
          currentStep: this.currentStep,
          selectedDate: this.selectedDate,
          selectedFrequency: this.selectedFrequency
        });
        
        // Validate date
        const selectedDateOption = this.selector.querySelector('.date-option.selected');
        if (!this.selectedDate && !selectedDateOption) {
          this.showValidationError('date');
          return false;
        }
        
        try {
          await this.confirmSelection();
        } catch (err) {
          console.error('[Delivery] confirmSelection', err);
          this.hideCheckoutLoader();
        }
      });
    }
    
    // Try to set the selected date from the UI if it's not already set
    if (!this.selectedDate) {
      this.setSelectedDateFromUI();
    }
    
    // Remove any existing back buttons to prevent duplicates
    const existingBackButtons = buttonContainer.querySelectorAll('.back-btn');
    existingBackButtons.forEach(btn => btn.remove());
    
    // Create a new back button
    const backButton = document.createElement('button');
    backButton.className = 'back-btn';
    backButton.innerHTML = '<span class="arrow back-arrow">→</span> חזרה';
    backButton.setAttribute('data-action', 'back-step');
    backButton.setAttribute('type', 'button'); // Ensure it's not a submit button
    
    // Add event listener with direct function call
    backButton.onclick = () => {
      console.log('Back button clicked - direct call');
      this.currentStep = 1; // Force to step 1
      this.clearValidationMessages();
      this.updateStepUI();
      this.updateConfirmButtonText();
      this.updateButtonLayout();
    };
    
    // Insert at the beginning of button container
    buttonContainer.insertBefore(backButton, buttonContainer.firstChild);
    
    // Get the new confirm button reference
    const newConfirmButton = buttonContainer.querySelector('[data-action="confirm"]');
    
    // Check if we have selections and update button state
    const hasDateSelected = this.selectedDate || this.selector.querySelector('.date-option.selected');
    const hasFrequencySelected = this.selectedFrequency || this.selector.querySelector('.frequency-option.selected');
    
    if (newConfirmButton) {
      // Enable the button if we have the appropriate selection for the current step
      if ((this.currentStep === 1 && hasDateSelected) || 
          (this.currentStep === 2 && hasFrequencySelected)) {
        newConfirmButton.disabled = false;
        newConfirmButton.classList.remove('disabled');
        newConfirmButton.style.opacity = '1';
      }
      
      // Update layout based on current step
      if (this.currentStep === 1) {
        // First step: full width button, hide back button
        backButton.style.display = 'none';
        newConfirmButton.style.width = '100%';
      } else {
        // Second step: reduced width button, show back button
        backButton.style.display = 'inline-block';
        newConfirmButton.style.width = '80%';
      }
    }
  }

  // Add a method to directly set the selected date from the UI
  setSelectedDateFromUI() {
    const selectedDateOption = this.selector.querySelector('.date-option.selected');
    if (selectedDateOption) {
      const dayElement = selectedDateOption.querySelector('.date-day');
      const dateElement = selectedDateOption.querySelector('.date-number');
      
      if (dayElement && dateElement) {
        const dayName = dayElement.textContent;
        const dateText = dateElement.textContent;
        const selectedDate = this.parseDateFromText(dayName, dateText);
        
        if (selectedDate) {
          console.log("Setting selected date from UI:", selectedDate);
          this.selectedDate = selectedDate;
          return true;
        }
      }
    }
    return false;
  }

  /** Fire-and-forget wrapper (e.g. legacy callers); prefer `updateCartWithDeliveryInfoAsync` on critical path. */
  updateCartWithDeliveryInfo() {
    void this.updateCartWithDeliveryInfoAsync().catch((error) => {
      console.error('Error updating cart with delivery info', error);
    });
  }

  async updateCartWithDeliveryInfoAsync() {
    deliveryCheckoutDebugStep('updateCartWithDeliveryInfoAsync:start');
    console.log('Updating cart with delivery info', {
      date: this.selectedDate,
      frequency: this.selectedFrequency,
    });

    const formattedDate = this.selectedDate
      ? `${this.getDayNameHebrew(this.selectedDate)}, ${this.formatDate(this.selectedDate)}`
      : '';

    const translatedFrequency = this.selectedFrequency ? this.getTranslatedFrequency(this.selectedFrequency) : '';

    const attrs = {
      Delivery_Date: this.selectedDate ? this.selectedDate.toISOString() : '',
      Formatted_Delivery_Date: formattedDate,
      'Delivery Frequency': this.selectedFrequency || '',
      Translated_Frequency: translatedFrequency,
    };
    if (this._pendingBoostifyOrderRepeatForCheckout !== undefined) {
      attrs[BOOSTIFY_CART_ATTR_ORDER_REPEAT] =
        this._pendingBoostifyOrderRepeatForCheckout === '' || this._pendingBoostifyOrderRepeatForCheckout == null
          ? ''
          : String(this._pendingBoostifyOrderRepeatForCheckout);
    }

    const cartUpdateData = { attributes: attrs };

    const response = await fetch(shopifyCartJsonPath('cart/update.js'), {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(cartUpdateData),
    });

    if (!response.ok) {
      const text = await response.text();
      throw new Error(text || `cart/update failed ${response.status}`);
    }

    const cart = await response.json();
    if (this._pendingBoostifyOrderRepeatForCheckout !== undefined) {
      this._pendingBoostifyOrderRepeatForCheckout = undefined;
    }
    deliveryCheckoutDebugStep('updateCartWithDeliveryInfoAsync:cart/update.js done');
    console.log('Cart updated with delivery info', cart);

    document.dispatchEvent(
      new CustomEvent('delivery-info-updated', {
        detail: {
          date: formattedDate,
          frequency: translatedFrequency,
        },
      })
    );

    return cart;
  }

  // Add a method to get discount information for each frequency option
  getDiscountInfo(frequency) {
    const discountInfo = {
      'weekly': '10% הנחה על ההזמנה הבאה',
      'biweekly': '5% הנחה על ההזמנה הבאה',
      'monthly': 'הפתעה טעימה',
      'onetime': ''
    };
    
    return discountInfo[frequency] || '';
  }

  // Update the shipping label based on selected frequency
  updateShippingLabel() {
    const freeShippingLabel = this.selector.querySelector('[data-free-shipping]');
    const paidShippingLabel = this.selector.querySelector('[data-paid-shipping]');
    
    // Hide both labels initially
    freeShippingLabel.classList.add('hidden');
    paidShippingLabel.classList.add('hidden');
    
    // Show appropriate label based on frequency
    if (this.selectedFrequency) {
      let discountText = '';
      
      // Set discount text based on frequency
      if (this.selectedFrequency === 'weekly') {
        discountText = 'חסכו 10% להזמנות חוזרות';
        paidShippingLabel.textContent = discountText;
        paidShippingLabel.classList.remove('hidden');
      } else if (this.selectedFrequency === 'biweekly') {
        discountText = 'חסכו 5% להזמנות חוזרות';
        paidShippingLabel.textContent = discountText;
        paidShippingLabel.classList.remove('hidden');
      } else if (this.selectedFrequency === 'monthly') {
        discountText = 'הפתעה טעימה בהזמנות חוזרות';
        paidShippingLabel.textContent = discountText;
        paidShippingLabel.classList.remove('hidden');
      }
    }
  }

  handleDeliveryDatesReload(event) {
    // Check if the cart state has changed
    const currentOutOfStock = this.checkCartForOutOfStockItems();
    const currentItemCount = document.querySelectorAll('.cart-item').length;
    
    const cartChanged = 
      currentOutOfStock !== this.cartState.hasOutOfStock || 
      currentItemCount !== this.cartState.itemCount;
    
    // Update the cart state
    this.cartState = {
      hasOutOfStock: currentOutOfStock,
      itemCount: currentItemCount
    };
    
    // If the cart has changed, regenerate the date options
    if (cartChanged) {
      // Reset selected date if cart has changed significantly
      if (event.detail.action === 'remove' || event.detail.action === 'refresh') {
        this.selectedDate = null;
        localStorage.removeItem('tempSelectedDate');
        localStorage.removeItem('selectedDeliveryDate');
      }
      
      this.scheduleGenerateDateOptions();

      this.updateUI();
      
      // Update any displayed delivery info in the cart
      this.displaySavedSelectionsInCart();
    }
  }

  getCutoffHour(dayName) {
    return window.deliverySettings?.cutoffHours?.[dayName] || 1;
  }

  /** Sunday delivery: orders close Thursday 23:59:59.999 before that Sunday (browser local time). */
  getSundayOrderCutoffDateTime(deliverySundayDate) {
    const d = new Date(
      deliverySundayDate.getFullYear(),
      deliverySundayDate.getMonth(),
      deliverySundayDate.getDate()
    );
    d.setDate(d.getDate() - 3);
    d.setHours(23, 59, 59, 999);
    return d;
  }

  compareCartWithLastOrder() {
    console.log('Comparing cart with last order...');
    
    // Get the last order variants from the hidden input
    const lastOrderInput = document.getElementById('lastOrderVariants');
    if (!lastOrderInput) {
      console.log('No last order input found');
      return;
    }
    
    // Check if customer has a subscription
    const customerSubscriptionElement = document.querySelector('[data-customer-subscription]');
    if (!customerSubscriptionElement || !customerSubscriptionElement.getAttribute('data-customer-subscription')) {
      console.log('Customer does not have a subscription');
      return;
    }
    
    // Get the cart comparison status element and make sure it's visible
    const cartComparisonStatus = this.selector.querySelector('.cart-comparison-status');
    if (cartComparisonStatus) {
      cartComparisonStatus.style.display = 'block';
    }
    
    console.log('Last order input:', lastOrderInput);
    const lastOrderString = lastOrderInput.value;
    console.log('Last order string:', lastOrderString);
    
    if (!lastOrderString) {
      console.log('No last order string');
      return;
    }
    
    // Parse the last order variants
    const lastOrderVariants = {};
    lastOrderString.split(',').forEach(item => {
      const [variantId, quantity] = item.split(':');
      lastOrderVariants[variantId] = parseInt(quantity);
    });
    console.log('Last order variants:', lastOrderVariants);
    
    // Get the current cart items
    const cartItems = document.querySelectorAll('.cart-form-item, .cart-item, [data-cart-item], [data-js-cart-item]');
    console.log('Cart items:', cartItems);
    
    if (!cartItems.length) {
      console.log('No cart items found');
      return;
    }
    
    // Check if there's already a discount applied to the cart
    const existingDiscounts = document.querySelectorAll('.cart__discounts');
    let hasExistingDiscount = false;
    
    existingDiscounts.forEach(discount => {
      // If there's a discount that's not our subscription discount
      if (discount.textContent && !discount.textContent.includes('Subscription_Discount') && !discount.classList.contains('hide-loyalfan-discount')) {
        hasExistingDiscount = true;
      }
    });
    
    console.log('Has existing discount:', hasExistingDiscount);
    
    // Create a map of current cart items
    const currentCartVariants = {};
    cartItems.forEach(item => {
      let variantId = item.id;
      
      // Try to get variant ID from different possible attributes
      if (!variantId) {
        variantId = item.getAttribute('data-variant-id') || 
                   item.getAttribute('data-id') || 
                   item.getAttribute('data-item-id') ||
                   item.getAttribute('data-cart-item');
      }
      
      // If still no variant ID, try to find it in a child element
      if (!variantId) {
        const variantIdElement = item.querySelector('[data-variant-id]') || 
                                item.querySelector('[data-id]') || 
                                item.querySelector('[data-item-id]');
        if (variantIdElement) {
          variantId = variantIdElement.getAttribute('data-variant-id') || 
                     variantIdElement.getAttribute('data-id') || 
                     variantIdElement.getAttribute('data-item-id');
        }
      }
      
      // Extract just the number from the variant ID if it contains other text
      if (variantId && typeof variantId === 'string') {
        const match = variantId.match(/\d+/);
        if (match) {
          variantId = match[0];
        }
      }
      
      if (variantId) {
        // Try to get quantity from different possible elements
        let quantity = 1;
        const quantityInput = item.querySelector('input[name="quantity"], [data-quantity-input], [data-item-quantity]');
        if (quantityInput) {
          quantity = parseInt(quantityInput.value || quantityInput.getAttribute('value') || 1);
        } else {
          const quantityElement = item.querySelector('[data-quantity], [data-item-quantity]');
          if (quantityElement) {
            quantity = parseInt(quantityElement.textContent || quantityElement.getAttribute('data-quantity') || 1);
          }
        }
        
        currentCartVariants[variantId] = (currentCartVariants[variantId] || 0) + quantity;
      }
    });
    console.log('Current cart variants:', currentCartVariants);
    
    // Compare the variants
    let isMatching = true;
    let hasAllLastOrderItems = true;
    
    // Check if all last order items are in the current cart with at least the same quantity
    for (const [variantId, quantity] of Object.entries(lastOrderVariants)) {
      if (!currentCartVariants[variantId] || currentCartVariants[variantId] < quantity) {
        hasAllLastOrderItems = false;
        break;
      }
    }
    
    // Check if the current cart has exactly the same items as the last order
    isMatching = hasAllLastOrderItems && Object.keys(lastOrderVariants).length === Object.keys(currentCartVariants).length;
    
    // Get the last order total from the data attribute
    const lastOrderTotal = parseFloat(lastOrderInput.getAttribute('data-last-order-total') || 0);
    console.log('Last order total:', lastOrderTotal);
    
    // Get the current cart total
    let cartItemsSubtotal = 0;
    const cartFormEl = document.getElementById('AjaxCartForm');
    const cartSubtotalElement = cartFormEl
      ? cartFormEl.querySelector('[data-cart-items-subtotal]')
      : document.querySelector('[data-cart-items-subtotal]');
    if (cartSubtotalElement) {
      const subtotalText = cartSubtotalElement.textContent.replace(/[^0-9.]/g, '');
      cartItemsSubtotal = parseFloat(subtotalText);
    } else {
      const cartTotalEl = cartFormEl
        ? cartFormEl.querySelector('[data-cart-total]')
        : document.querySelector('.cart__total[data-cart-total]');
      if (cartTotalEl) {
        const totalText = cartTotalEl.textContent.replace(/[^0-9.]/g, '');
        cartItemsSubtotal = parseFloat(totalText);
      }
    }
    this.cartTotal = cartItemsSubtotal;
    console.log('Current cart total:', this.cartTotal);
    
    // Check if the current cart total is greater than or equal to the last order total
    const isTotalSameOrGreater = this.cartTotal >= lastOrderTotal;
    console.log('Is total same or greater:', isTotalSameOrGreater);
    
    // Configuration for discount application
    const discountConfig = {
      requireItemMatch: true,
      requireTotalMatch: true,
      matchType: 'both' // 'both', 'either', 'items_only', 'total_only'
    };
    
    // Determine if discount should be applied based on configuration
    let shouldApplyDiscount = false;
    
    if (discountConfig.matchType === 'both') {
      shouldApplyDiscount = isMatching && isTotalSameOrGreater;
    } else if (discountConfig.matchType === 'either') {
      shouldApplyDiscount = (discountConfig.requireItemMatch && isMatching) || 
                           (discountConfig.requireTotalMatch && isTotalSameOrGreater);
    } else if (discountConfig.matchType === 'items_only') {
      shouldApplyDiscount = isMatching;
    } else if (discountConfig.matchType === 'total_only') {
      shouldApplyDiscount = isTotalSameOrGreater;
    }
    
    // Don't apply discount if there's already a discount
    if (hasExistingDiscount) {
      shouldApplyDiscount = false;
    }
    
    console.log('Should apply discount:', shouldApplyDiscount);
    
    // Update the UI based on the comparison result
    const lastOrderLink = this.selector.querySelector('.last-order-link');
    const existingSubscription = this.selector.querySelector('.existing-subscription');
    
    if (lastOrderLink) {
      const statusText = lastOrderLink.querySelector('.text');
      
      if (isMatching) {
        lastOrderLink.classList.add('is-matching');
        lastOrderLink.classList.remove('not-matching');
        statusText.innerHTML = '✓ תואם להזמנה האחרונה שלך';
        statusText.style.color = '#4CAF50';
        
        // Add total comparison message
        let totalComparisonMessage = '';
        if (isTotalSameOrGreater) {
          totalComparisonMessage = `<div style="color: #4CAF50; margin-top: 5px;">✓ הסכום הנוכחי (${this.cartTotal} ₪) שווה או גבוה מההזמנה האחרונה (${lastOrderTotal} ₪)</div>`;
        } else {
          totalComparisonMessage = `<div style="color: #ff385c; margin-top: 5px;">× הסכום הנוכחי (${this.cartTotal} ₪) נמוך מההזמנה האחרונה (${lastOrderTotal} ₪)</div>`;
        }
        
        // Only show the total comparison message if we don't have an existing discount
        if (!hasExistingDiscount) {
          lastOrderLink.insertAdjacentHTML('afterend', totalComparisonMessage);
        }
      } else {
        lastOrderLink.classList.add('not-matching');
        lastOrderLink.classList.remove('is-matching');
        statusText.innerHTML = '× לא תואם להזמנה האחרונה שלך';
        statusText.style.color = '#ff385c';
        
        // Remove any existing total comparison message
        const existingTotalMessage = this.selector.querySelector('.last-order-link + div');
        if (existingTotalMessage) {
          existingTotalMessage.remove();
        }
      }
    }
    
    if (existingSubscription) {
      if (isMatching) {
        existingSubscription.textContent = 'חידוש הזמנה למנוי';
      } else {
        existingSubscription.textContent = 'עדכון מנוי קיים';
      }
    }
    
    // Update the subscription tag text in the frequency options
    const subscriptionTag = this.selector.querySelector('.existing-subscription-tag');
    if (subscriptionTag) {
      if (isMatching) {
        subscriptionTag.textContent = 'חידוש הזמנה למנוי';
      } else {
        subscriptionTag.textContent = 'עדכון מנוי קיים';
      }
    }
    
    // Also update any subscription tags in the frequency options
    const frequencyOptionsTags = document.querySelectorAll('.frequency-option .existing-subscription-tag');
    frequencyOptionsTags.forEach(tag => {
      if (isMatching) {
        tag.textContent = 'חידוש הזמנה למנוי';
      } else {
        tag.textContent = 'עדכון מנוי קיים';
      }
    });
    
    // Apply or remove discount based on the comparison result
    if (shouldApplyDiscount && this.selectedFrequency) {
      // Apply discount based on frequency
      let discountPercentage = 0;
      if (this.selectedFrequency === 'weekly') {
        discountPercentage = 10;
      } else if (this.selectedFrequency === 'biweekly') {
        discountPercentage = 5;
      }
      
      if (discountPercentage > 0) {
        // Calculate discount amount
        const discountAmount = (this.cartTotal * discountPercentage / 100).toFixed(2);
        const discountedTotal = (this.cartTotal - discountAmount).toFixed(2);
        
        // Update cart attributes with discount information
        fetch('/cart/update.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            attributes: {
              'Subscription_Discount_Percentage': `${discountPercentage}%`,
              'Subscription_Discount_Amount': discountAmount,
              'Original_Total': this.cartTotal.toFixed(2),
              'Discounted_Total': discountedTotal
            }
          })
        })
        .then(response => response.json())
        .then(data => {
          console.log('Cart updated with discount:', data);
          
          // Update the displayed total
          if (this.totalAmountElement) {
            this.totalAmountElement.textContent = discountedTotal;
          }
          
          // Show discount message
          const discountMessage = `<div style="color: #4CAF50; margin-top: 5px; font-weight: 500;">חסכת ${discountAmount} ₪ (${discountPercentage}% הנחה)</div>`;
          const existingDiscountMessage = this.selector.querySelector('.discount-message');
          
          if (existingDiscountMessage) {
            existingDiscountMessage.innerHTML = discountMessage;
          } else {
            const totalLabel = this.selector.querySelector('.total-label');
            if (totalLabel) {
              totalLabel.insertAdjacentHTML('afterend', `<div class="discount-message">${discountMessage}</div>`);
            }
          }
        })
        .catch(error => {
          console.error('Error updating cart with discount:', error);
        });
      }
    } else {
      // Remove any existing discount
      fetch('/cart/update.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          attributes: {
            'Subscription_Discount_Percentage': null,
            'Subscription_Discount_Amount': null,
            'Original_Total': null,
            'Discounted_Total': null
          }
        })
      })
      .then(response => response.json())
      .then(data => {
        console.log('Cart updated, discount removed:', data);
        
        // Reset the displayed total to the original amount
        if (this.totalAmountElement) {
          this.totalAmountElement.textContent = this.cartTotal.toFixed(2);
        }
        
        // Remove discount message
        const discountMessage = this.selector.querySelector('.discount-message');
        if (discountMessage) {
          discountMessage.remove();
        }
      })
      .catch(error => {
        console.error('Error updating cart, removing discount:', error);
      });
    }
    
    return isMatching;
  }

  // Add a method to check if a date is a blackout date
  isBlackoutDate(date) {
    // Get blackout dates from settings
    const blackoutDates = window.deliverySettings?.blackoutDates || [];

    // If no blackout dates or contains 'none', return false
    if (blackoutDates.length === 0 || blackoutDates.includes('none')) {
      return false;
    }
    
    // Normalize date to start of day in Israel time zone
    const normalizedDate = new Date(date);
    normalizedDate.setHours(0, 0, 0, 0);
    
    // Format the date to YYYY-MM-DD for comparison
    const year = normalizedDate.getFullYear();
    const month = (normalizedDate.getMonth() + 1).toString().padStart(2, '0');
    const day = normalizedDate.getDate().toString().padStart(2, '0');
    const dateString = `${year}-${month}-${day}`;
    
    // Check if the dateString is in the blackoutDates array
    const isBlackout = blackoutDates.includes(dateString);
    
    if (isBlackout) {
      console.log(`Date ${dateString} is a blackout date`);
    }
    
    return isBlackout;
  }
  
  // Add a method to check if a date is a one-time delivery date
  isOneTimeDate(date) {
    // Get one-time dates from settings
    const oneTimeDates = window.deliverySettings?.oneTimeDates || [];
    
    // If no one-time dates or contains 'none', return false
    if (oneTimeDates.length === 0 || oneTimeDates.includes('none')) {
      return false;
    }
    
    // Normalize date to start of day in Israel time zone
    const normalizedDate = new Date(date);
    normalizedDate.setHours(0, 0, 0, 0);
    
    // Format the date to YYYY-MM-DD for comparison
    const year = normalizedDate.getFullYear();
    const month = (normalizedDate.getMonth() + 1).toString().padStart(2, '0');
    const day = normalizedDate.getDate().toString().padStart(2, '0');
    const dateString = `${year}-${month}-${day}`;
    
    // Check if any of the one-time dates match
    for (const oneTimeDate of oneTimeDates) {
      // Skip empty entries
      if (!oneTimeDate || oneTimeDate === 'none') continue;
      
      // Try direct string comparison first
      if (oneTimeDate.trim() === dateString) {
        console.log(`Date ${dateString} is a one-time delivery date (exact match)`);
        return true;
      }
      
      // Parse parts from YYYY-MM-DD format
      const parts = oneTimeDate.trim().split('-');
      if (parts.length === 3) {
        const otYear = parseInt(parts[0], 10);
        const otMonth = parseInt(parts[1], 10);
        const otDay = parseInt(parts[2], 10);
        
        // Compare with normalized date components
        const normalizedYear = normalizedDate.getFullYear();
        const normalizedMonth = normalizedDate.getMonth() + 1; // JavaScript months are 0-based
        const normalizedDay = normalizedDate.getDate();
        
        if (otYear === normalizedYear && otMonth === normalizedMonth && otDay === normalizedDay) {
          console.log(`Date ${dateString} is a one-time delivery date (parts match)`);
          return true;
        }
      }
    }
    
    return false;
  }
};

// Initialize the delivery frequency selector when the DOM is loaded
document.addEventListener('DOMContentLoaded', () => {
  console.log('DOM loaded, initializing delivery frequency selector');
  
  // Initialize selectors - Fix the selector for cart drawer
  const cartDrawerSelector = document.querySelector('#DrawerDeliveryFrequencySelector');
  const cartPageSelector = document.querySelector('.delivery-frequency-modal');
  
  // Create instances
  let drawerInstance = null;
  let pageInstance = null;
  
  if (cartDrawerSelector && cartDrawerSelector.dataset.deliveryFrequencyInit !== '1') {
    console.log('Found cart drawer selector');
    cartDrawerSelector.dataset.deliveryFrequencyInit = '1';
    drawerInstance = new DeliveryFrequencySelector(cartDrawerSelector);
  }
  
  if (cartPageSelector && cartPageSelector.dataset.deliveryFrequencyInit !== '1') {
    console.log('Found cart page selector');
    cartPageSelector.dataset.deliveryFrequencyInit = '1';
    pageInstance = new DeliveryFrequencySelector(cartPageSelector);
  }
  
  // Hide LOYALFAN discount in cart
  function hideLoyalfanDiscount() {
    const discountElements = document.querySelectorAll('.cart__discounts');
    discountElements.forEach(element => {
      if (element.textContent.includes('LOYALFAN')) {
        element.classList.add('hide-loyalfan-discount');
      }
    });
  }
  
  // Run initially
  hideLoyalfanDiscount();
  
  // Handle checkout button clicks
  function handleCheckoutButtonClick() {
    const checkoutButtons = document.querySelectorAll('#CheckOut');
    
    checkoutButtons.forEach(button => {
      // Skip if already handled by this function
      if (button.hasAttribute('data-delivery-handler-attached')) {
        return;
      }
      
      // Mark as handled by this function
      button.setAttribute('data-delivery-handler-attached', 'true');
      
      // Add our click handler without replacing the button
      button.addEventListener('click', function(e) {
        e.preventDefault();
        
        // Determine if this is the cart page or drawer
        const isCartPage = window.location.pathname.includes('/cart') || 
                           this.closest('.cart__subtotal-widget') !== null;
        
        // Find the appropriate delivery selector
        let deliverySelector;
        if (isCartPage) {
          // For cart page - use the modal version
          deliverySelector = document.querySelector('#DeliveryFrequencySelector.delivery-frequency-modal');
        } else {
          // For drawer cart - use the slide-up version
          deliverySelector = document.querySelector('#DrawerDeliveryFrequencySelector');
        }
        
        if (deliverySelector) {
          // Show the delivery selector
          deliverySelector.style.display = 'block';
          
          // Show the panel and overlay with animation
          const panel = deliverySelector.querySelector('.delivery-date-panel');
          const overlay = deliverySelector.querySelector('.delivery-panel-overlay');
          
          if (overlay) {
            overlay.style.display = 'block';
          }
          
          const isDrawerOpen = deliverySelector.id === 'DrawerDeliveryFrequencySelector';
          if (isDrawerOpen && panel) {
            panel.classList.add('show');
          } else {
            setTimeout(() => {
              if (panel) panel.classList.add('show');
            }, 10);
          }
          
          document.body.style.overflow = 'hidden';
          
          // Find the instance for this selector
          const instance = window.deliveryFrequencyInstances.find(
            inst => inst.selector === deliverySelector
          );
          
          if (instance) {
            instance.currentStep = 1;
            if (instance.orderTypeFlowEnabled) {
              instance.orderTypePhase = 'date';
              if (instance.orderTypePanel) {
                instance.orderTypePanel.classList.remove('show');
                instance.orderTypePanel.setAttribute('hidden', '');
              }
            }
            instance.syncDeliveryFlowSteppers(1);
            instance.updateUI();
          }
        } else {
          // If no delivery selector is found, proceed to checkout
          document.getElementById('cart').submit();
        }
      });
    });
  }
  
  // Set up checkout buttons
  handleCheckoutButtonClick();
  
  let _deliveryCartPostDebounce = null;
  document.addEventListener('cart-updated', function () {
    if (_deliveryCartPostDebounce) clearTimeout(_deliveryCartPostDebounce);
    _deliveryCartPostDebounce = setTimeout(function () {
      _deliveryCartPostDebounce = null;
      handleCheckoutButtonClick();
      if (window.deliveryFrequencyInstances && window.deliveryFrequencyInstances.length > 0) {
        window.deliveryFrequencyInstances.forEach((instance) => {
          if (!instance) return;
          if (typeof instance.setCartTotal === 'function') instance.setCartTotal();
          if (typeof instance.displaySavedSelectionsInCart === 'function') {
            instance.displaySavedSelectionsInCart();
          }
        });
      }
      hideLoyalfanDiscount();
    }, 200);
  });

  document.addEventListener('show-delivery-selector', function (e) {
    if (e.detail && e.detail.isDrawer && drawerInstance) {
      drawerInstance.showDeliverySelector(true);
    } else if (pageInstance) {
      pageInstance.showDeliverySelector(false);
    } else if (e.detail && e.detail.isDrawer && window.deliveryFrequencyInstances) {
      const fallback = window.deliveryFrequencyInstances.find(
        (inst) => inst && inst.selector && inst.selector.id === 'DrawerDeliveryFrequencySelector'
      );
      if (fallback) fallback.showDeliverySelector(true);
    }
  });
}); 
 